import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _inherits from '@babel/runtime/helpers/inherits';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React, { Component, forwardRef, Fragment, Suspense } from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { combineReducers, applyMiddleware, createStore, bindActionCreators } from 'redux';
import { createUndoMiddleware, undoHistoryReducer, actions as actions$2 } from 'redux-undo-redo';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _ from 'lodash';
import { connect, Provider } from 'react-redux';
import { withTranslation, I18nextProvider } from 'react-i18next';
import PropTypes from 'prop-types';
import { faPrint, faFile, faFolder, faSave, faPen, faQrcode, faBarcode, faMinus, faBold, faItalic, faUnderline, faPaintBrush, faCopy, faDownload, faFileImport, faSpinner, faAlignLeft, faAlignRight, faAlignCenter, faImage, faImagePortrait, faRotateLeft, faRotateRight, faEye, faT, faCode, faXmark } from '@fortawesome/free-solid-svg-icons';
import { faCircle, faSquare } from '@fortawesome/free-regular-svg-icons';
import _extends from '@babel/runtime/helpers/extends';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { Line, Transformer, Rect, Text, Image, Ellipse, Stage, Layer } from 'react-konva';
import bwipjs from 'bwip-js';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import ReactFileReader from 'react-file-reader';
import Select from 'react-select';
import i18n from 'i18next';
export { default as i18n } from 'i18next';
import HttpApi from 'i18next-http-backend';

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$d = ".container__width {\n  max-width: 100% !important;\n  padding: 0; }\n\n.content__container {\n  height: 800px; }\n\n.margin-0 {\n  margin: 0; }\n\n.scroll {\n  overflow: auto; }\n  .scroll::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n    background-color: #206087;\n    border-radius: 0.35rem; }\n  .scroll::-webkit-scrollbar {\n    width: 0.75rem;\n    height: 0.75rem; }\n  .scroll::-webkit-scrollbar-thumb {\n    background-color: #308dc7;\n    border-radius: 0.35rem;\n    border: 1px solid #cbd3da; }\n\n.new-label-container {\n  border: 1px solid black; }\n\n.cursor-pointer {\n  cursor: pointer; }\n\n.ep-btn {\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  -webkit-user-select: none;\n  user-select: none;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  border-radius: 0.25rem;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d; }\n  .ep-btn-primary {\n    color: #fff;\n    background-color: #007bff;\n    border-color: #007bff; }\n  .ep-btn-bordered {\n    border: 1px solid #ced4da; }\n  .ep-btn-disabled {\n    opacity: 0.5; }\n  .ep-btn:hover {\n    filter: brightness(120%);\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n    border-color: #fff; }\n\n.ep-input {\n  display: block;\n  width: 100%;\n  height: calc(1.5em + .75rem + 2px);\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: .25rem;\n  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out; }\n  .ep-input-sm {\n    height: calc(1.5em + .5rem + 2px);\n    padding: .25rem .5rem;\n    font-size: .875rem;\n    line-height: 1.5;\n    border-radius: .2rem;\n    margin-top: -8px; }\n  .ep-input-checkbox {\n    color: #007bff;\n    height: 1.5rem; }\n  .ep-input-disabled {\n    opacity: .65; }\n  .ep-input-bordered {\n    border: 1px solid #ced4da; }\n  .ep-input-plaintext {\n    color: #fff;\n    border: 1px solid transparent;\n    background-color: transparent; }\n    .ep-input-plaintext:focus {\n      background-color: #fff;\n      color: #000; }\n    .ep-input-plaintext:hover {\n      background-color: #fff;\n      color: #000; }\n\n.ep-navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: .5rem 1rem; }\n\n.ep-nav {\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  margin-bottom: 0;\n  padding-left: 0;\n  flex-direction: column; }\n\n.ep-modal-backdrop {\n  display: block;\n  height: 100%;\n  left: 0;\n  overflow: hidden;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 1050;\n  background-color: rgba(0, 0, 0, 0.5); }\n\n.ep-modal-dialog {\n  background-color: white;\n  position: fixed;\n  top: 50px;\n  left: 50%;\n  margin: 1.75rem auto;\n  max-width: 500px;\n  min-width: 500px;\n  transform: translate(-50%, 0);\n  transition: transform .3s ease-out;\n  border-radius: 1rem;\n  z-index: 1051; }\n\n.ep-modal-header {\n  align-items: flex-start;\n  border-bottom: 1px solid #dee2e6;\n  border-top-left-radius: calc(1rem - 1px);\n  border-top-right-radius: calc(1rem - 1px);\n  display: flex;\n  justify-content: space-between;\n  padding: 1rem;\n  line-height: 1.5;\n  margin-bottom: 0;\n  font-weight: 1000;\n  font-size: 1.25rem; }\n  .ep-modal-header h5 {\n    margin: 0; }\n\n.ep-modal-body {\n  flex: 1 1 auto;\n  padding: 1rem;\n  position: relative; }\n\n.ep-modal-footer {\n  align-items: normal;\n  border-bottom-left-radius: calc(1rem - 1px);\n  border-bottom-right-radius: calc(1rem - 1px);\n  border-top: 1px solid #dee2e6;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  padding: .75rem; }\n";
styleInject(css_248z$d);

function globalizeSelectors(selectors, mountPath) {
  var result = {};
  // eslint-disable-next-line no-unused-vars
  var _loop = function _loop() {
    var func = selectors[funcName];
    result[funcName] = function (state) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return func.apply(void 0, [_.get(state, mountPath)].concat(args));
    };
  };
  for (var funcName in selectors) {
    _loop();
  }
  return result;
}

function ownKeys$n(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$n(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$n(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$n(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var types$1 = {
  RESET_LAYOUT: 'LAYOUT/RESET_LAYOUT',
  CREATE_ITEM: 'LAYOUT/CREATE_ITEM',
  UPDATE_ITEM: 'LAYOUT/UPDATE_ITEM',
  DELETE_ITEM: 'LAYOUT/DELETE_ITEM',
  MOVE_ITEM_UP: 'LAYOUT/MOVE_ITEM_UP',
  MOVE_ITEM_DOWN: 'LAYOUT/MOVE_ITEM_DOWN',
  MOVE_ITEM_TOP: 'LAYOUT/MOVE_ITEM_TOP',
  MOVE_ITEM_BOTTOM: 'LAYOUT/MOVE_ITEM_BOTTOM',
  MOVE_ITEM: 'LAYOUT/MOVE_ITEM',
  LOAD: 'LAYOUT/LOAD',
  UPDATE_PAGE: 'LAYOUT/UPDATE_PAGE',
  EDIT_PROPERTIES: 'LAYOUT/EDIT_PROPERTIES',
  UPDATE_LABELVARIABLES: 'LAYOUT/UPDATE_LABELVARIABLES',
  READ_ONLY: 'LAYOUT/READ_ONLY',
  SET_INITIAL_LAYOUT: 'LAYOUT/SET_INITIAL_LAYOUT',
  SET_ORIENTATION: 'LAYOUT/SET_ORIENTATION'
};
var actions$1 = {
  setInitialLayout: function setInitialLayout(layout) {
    return {
      type: types$1.SET_INITIAL_LAYOUT,
      payload: layout
    };
  },
  createItem: function createItem(item) {
    return {
      type: types$1.CREATE_ITEM,
      payload: item
    };
  },
  updateItem: function updateItem(item) {
    return {
      type: types$1.UPDATE_ITEM,
      payload: item
    };
  },
  deleteItem: function deleteItem(item) {
    return {
      type: types$1.DELETE_ITEM,
      payload: item
    };
  },
  resetLayout: function resetLayout() {
    return {
      type: types$1.RESET_LAYOUT,
      payload: null
    };
  },
  // Changing the order of items to alter z order
  moveItemUp: function moveItemUp(item) {
    return {
      type: types$1.MOVE_ITEM_UP,
      payload: item
    };
  },
  moveItemDown: function moveItemDown(item) {
    return {
      type: types$1.MOVE_ITEM_DOWN,
      payload: item
    };
  },
  moveItemTop: function moveItemTop(item) {
    return {
      type: types$1.MOVE_ITEM_TOP,
      payload: item
    };
  },
  moveItemBottom: function moveItemBottom(item) {
    return {
      type: types$1.MOVE_ITEM_BOTTOM,
      payload: item
    };
  },
  load: function load(layout) {
    return {
      type: types$1.LOAD,
      payload: layout
    };
  },
  updatePage: function updatePage(page) {
    return {
      type: types$1.UPDATE_PAGE,
      payload: page
    };
  },
  updateLabelVariables: function updateLabelVariables(variables) {
    return {
      type: types$1.UPDATE_LABELVARIABLES,
      payload: variables
    };
  },
  updateReadOnly: function updateReadOnly(layout) {
    return {
      type: types$1.READ_ONLY,
      payload: layout
    };
  },
  setOrientation: function setOrientation(value) {
    return {
      type: types$1.SET_ORIENTATION,
      payload: value
    };
  }
};
var mountPath$1 = 'layout'; // mount point in global state, must match root reducer

var ORIENTATION_PORTRAIT = 'portrait';
var ORIENTATION_LANDSCAPE = 'landscape';
var initial_state$1 = {
  items: {},
  // to map items ids to items
  itemids: [],
  // to maintain order of items
  width: {
    pixel: 340,
    mm: 90
  },
  // width
  height: {
    pixel: 110,
    mm: 29
  },
  // height
  marginTop: 0,
  // editor page margins in mm
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  orientation: ORIENTATION_LANDSCAPE,
  values: {
    country: 'Finland',
    email: 'example@yahoo.com',
    postalCode: '01380, Vantaa, Finland',
    website: 'www.easyprint.com',
    companyname: 'Chromaflo Oy',
    siteaddress: 'Heidofintie 6, Vantaa',
    siteinfo: 'site info',
    innovatint: 'Innovatint lab',
    orderinfo: 'order info',
    defaultcurrency: 'default currency',
    selectedcurrency: 'selected currency',
    extrainfo: 'extra info',
    formula: 'Formula',
    formulainline: 'Formula Inline',
    dateandtimes: 'Date and Times',
    sitephone: 'site phone',
    sitename: 'site name'
  }
};
function reducer$2() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial_state$1;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var item = action.payload;
  switch (action.type) {
    case types$1.RESET_LAYOUT:
      {
        return initial_state$1;
      }
    case types$1.SET_INITIAL_LAYOUT:
      {
        // If null passed as initial layout then use the layout provided by initial state
        if (item !== null) {
          return item;
        }
        return initial_state$1;
      }
    case types$1.LOAD:
      {
        // If null passed as initial layout then use the layout provided by initial state
        if (item !== null) {
          return _objectSpread$n(_objectSpread$n({}, state), {}, {
            items: item.items || {},
            // to map items ids to items
            itemids: item.itemids || [],
            // to maintain order of items
            width: item.width || {
              pixel: 340,
              mm: 90
            },
            // width
            height: item.height || {
              pixel: 110,
              mm: 29
            },
            // height
            marginTop: item.marginTop || 0,
            // editor page margins in mm
            marginBottom: item.marginBottom || 0,
            marginLeft: item.marginLeft || 0,
            marginRight: item.marginRight || 0,
            orientation: item.orientation || ORIENTATION_LANDSCAPE
          });
        }
        return initial_state$1;
      }
    case types$1.CREATE_ITEM:
      {
        var itemTypeNameCount = localSelectors$1.itemsAsArray(state).find(function (el) {
          return el.itemType === item.itemType;
        }) && localSelectors$1.itemsAsArray(state).reverse().find(function (el) {
          return el.itemType === item.itemType;
        }).name;
        item = _objectSpread$n(_objectSpread$n({}, item), {}, {
          name: itemTypeNameCount ? item.itemType + (Number(itemTypeNameCount.substring(itemTypeNameCount.length - 1, itemTypeNameCount.length)) + 1).toString() : item.itemType + 1
        });
        return _objectSpread$n(_objectSpread$n({}, state), {}, {
          items: _objectSpread$n(_objectSpread$n({}, state.items), {}, _defineProperty({}, item.id, item)),
          itemids: [].concat(_toConsumableArray(state.itemids), [item.id])
        });
      }
    case types$1.UPDATE_PAGE:
      {
        return _objectSpread$n(_objectSpread$n({}, state), item);
      }
    case types$1.UPDATE_LABELVARIABLES:
      {
        return _objectSpread$n(_objectSpread$n({}, state), item);
      }
    case types$1.UPDATE_ITEM:
      {
        return _objectSpread$n(_objectSpread$n({}, state), {}, {
          items: _objectSpread$n(_objectSpread$n({}, state.items), {}, _defineProperty({}, item.id, _objectSpread$n({}, item)))
        });
      }
    case types$1.DELETE_ITEM:
      {
        var newItems = localSelectors$1.itemsAsArray(state).filter(function (el) {
          return el.id !== item.id;
        }).map(function (el) {
          return el.id > item.id ? _objectSpread$n(_objectSpread$n({}, el), {}, {
            id: el.id - 1,
            name: el.itemType === item.itemType ? el.itemType + (Number(el.name.substring(el.name.length - 1, el.name.length)) - 1).toString() : el.name
          }) : _objectSpread$n({}, el);
        }).reduce(function (obj, item) {
          obj[item.id] = _objectSpread$n({}, item);
          return obj;
        }, {});
        return _objectSpread$n(_objectSpread$n({}, state), {}, {
          items: newItems,
          itemids: state.itemids.filter(function (x) {
            return x !== item.id;
          }).map(function (x) {
            return x > item.id ? x - 1 : x;
          })
        });
      }

    // Moving itemid in itemids changes the z position of the item:
    case types$1.MOVE_ITEM_BOTTOM:
      {
        return _objectSpread$n(_objectSpread$n({}, state), {}, {
          itemids: [item.id].concat(_toConsumableArray(state.itemids.filter(function (x) {
            return x !== item.id;
          })))
        });
      }
    case types$1.MOVE_ITEM_TOP:
      {
        return _objectSpread$n(_objectSpread$n({}, state), {}, {
          itemids: [].concat(_toConsumableArray(state.itemids.filter(function (x) {
            return x !== item.id;
          })), [item.id])
        });
      }
    case types$1.MOVE_ITEM_DOWN:
      {
        var itemids = _toConsumableArray(state.itemids);
        var i = itemids.indexOf(item.id);
        if (i > 0) {
          itemids[i] = itemids[i - 1];
          itemids[i - 1] = item.id;
        }
        return _objectSpread$n(_objectSpread$n({}, state), {}, {
          itemids: itemids
        });
      }
    case types$1.SET_ORIENTATION:
      {
        return _objectSpread$n(_objectSpread$n({}, state), {}, {
          orientation: item
        });
      }
    case types$1.MOVE_ITEM_UP:
      {
        var _itemids = _toConsumableArray(state.itemids);
        var _i = _itemids.indexOf(item.id);
        if (_i < _itemids.length - 1) {
          _itemids[_i] = _itemids[_i + 1];
          _itemids[_i + 1] = item.id;
        }
        return _objectSpread$n(_objectSpread$n({}, state), {}, {
          itemids: _itemids
        });
      }
    default:
      {
        return state;
      }
  }
}
var localSelectors$1 = {
  itemById: function itemById(state, id) {
    return state.items[id];
  },
  itemsAsArray: function itemsAsArray(state) {
    return state.itemids.map(function (id) {
      return state.items[id];
    });
  }
};
var selectors$1 = globalizeSelectors(localSelectors$1, mountPath$1);

var undoMiddleware = createUndoMiddleware({
  getViewState: function getViewState(state) {
    return state.layout;
  },
  // setViewState: actions.updatePage,
  revertingActions: {
    'LAYOUT/CREATE_ITEM': function LAYOUT_CREATE_ITEM(_ref) {
      var payload = _ref.payload;
      return actions$1.deleteItem(payload.id);
    },
    'LAYOUT/DELETE_ITEM': {
      action: function action(_, _ref2) {
        var item = _ref2.item;
        return actions$1.createItem(item);
      },
      createArgs: function createArgs(state) {
        return {
          item: selectors$1.itemById(state, state.editor.selected_itemid)
        };
      }
    },
    'LAYOUT/UPDATE_ITEM': {
      action: function action(_, _ref3) {
        var item = _ref3.item;
        return actions$1.updateItem(item);
      },
      createArgs: function createArgs(state) {
        return {
          item: selectors$1.itemById(state, state.editor.selected_itemid)
        };
      }
    },
    'LAYOUT/UPDATE_PAGE': {
      action: function action(_, _ref4) {
        var oldLayout = _ref4.oldLayout;
        return actions$1.updatePage(oldLayout);
      },
      createArgs: function createArgs(state) {
        return {
          oldLayout: state.layout
        };
      }
    },
    'LAYOUT/MOVE_ITEM_DOWN': {
      action: function action(_ref5) {
        var payload = _ref5.payload;
        return actions$1.moveItemUp(payload);
      }
    },
    'LAYOUT/MOVE_ITEM_UP': {
      action: function action(_ref6) {
        var payload = _ref6.payload;
        return actions$1.moveItemDown(payload);
      }
    },
    'LAYOUT/MOVE_ITEM_TOP': {
      action: function action(_ref7) {
        var payload = _ref7.payload;
        return actions$1.moveItemBottom(payload);
      }
    },
    'LAYOUT/MOVE_ITEM_BOTTOM': {
      action: function action(_ref8) {
        var payload = _ref8.payload;
        return actions$1.moveItemTop(payload);
      }
    }
  }
});

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var reduxLogger = {exports: {}};

(function (module, exports) {
!function (e, t) {
  t(exports) ;
}(commonjsGlobal, function (e) {

  function t(e, t) {
    e.super_ = t, e.prototype = Object.create(t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    });
  }
  function r(e, t) {
    Object.defineProperty(this, "kind", {
      value: e,
      enumerable: !0
    }), t && t.length && Object.defineProperty(this, "path", {
      value: t,
      enumerable: !0
    });
  }
  function n(e, t, r) {
    n.super_.call(this, "E", e), Object.defineProperty(this, "lhs", {
      value: t,
      enumerable: !0
    }), Object.defineProperty(this, "rhs", {
      value: r,
      enumerable: !0
    });
  }
  function o(e, t) {
    o.super_.call(this, "N", e), Object.defineProperty(this, "rhs", {
      value: t,
      enumerable: !0
    });
  }
  function i(e, t) {
    i.super_.call(this, "D", e), Object.defineProperty(this, "lhs", {
      value: t,
      enumerable: !0
    });
  }
  function a(e, t, r) {
    a.super_.call(this, "A", e), Object.defineProperty(this, "index", {
      value: t,
      enumerable: !0
    }), Object.defineProperty(this, "item", {
      value: r,
      enumerable: !0
    });
  }
  function f(e, t, r) {
    var n = e.slice((r || t) + 1 || e.length);
    return e.length = t < 0 ? e.length + t : t, e.push.apply(e, n), e;
  }
  function u(e) {
    var t = "undefined" == typeof e ? "undefined" : N(e);
    return "object" !== t ? t : e === Math ? "math" : null === e ? "null" : Array.isArray(e) ? "array" : "[object Date]" === Object.prototype.toString.call(e) ? "date" : "function" == typeof e.toString && /^\/.*\//.test(e.toString()) ? "regexp" : "object";
  }
  function l(e, t, r, c, s, d, p) {
    s = s || [], p = p || [];
    var g = s.slice(0);
    if ("undefined" != typeof d) {
      if (c) {
        if ("function" == typeof c && c(g, d)) return;
        if ("object" === ("undefined" == typeof c ? "undefined" : N(c))) {
          if (c.prefilter && c.prefilter(g, d)) return;
          if (c.normalize) {
            var h = c.normalize(g, d, e, t);
            h && (e = h[0], t = h[1]);
          }
        }
      }
      g.push(d);
    }
    "regexp" === u(e) && "regexp" === u(t) && (e = e.toString(), t = t.toString());
    var y = "undefined" == typeof e ? "undefined" : N(e),
      v = "undefined" == typeof t ? "undefined" : N(t),
      b = "undefined" !== y || p && p[p.length - 1].lhs && p[p.length - 1].lhs.hasOwnProperty(d),
      m = "undefined" !== v || p && p[p.length - 1].rhs && p[p.length - 1].rhs.hasOwnProperty(d);
    if (!b && m) r(new o(g, t));else if (!m && b) r(new i(g, e));else if (u(e) !== u(t)) r(new n(g, e, t));else if ("date" === u(e) && e - t !== 0) r(new n(g, e, t));else if ("object" === y && null !== e && null !== t) {
      if (p.filter(function (t) {
        return t.lhs === e;
      }).length) e !== t && r(new n(g, e, t));else {
        if (p.push({
          lhs: e,
          rhs: t
        }), Array.isArray(e)) {
          var w;
          e.length;
          for (w = 0; w < e.length; w++) w >= t.length ? r(new a(g, w, new i(void 0, e[w]))) : l(e[w], t[w], r, c, g, w, p);
          for (; w < t.length;) r(new a(g, w, new o(void 0, t[w++])));
        } else {
          var x = Object.keys(e),
            S = Object.keys(t);
          x.forEach(function (n, o) {
            var i = S.indexOf(n);
            i >= 0 ? (l(e[n], t[n], r, c, g, n, p), S = f(S, i)) : l(e[n], void 0, r, c, g, n, p);
          }), S.forEach(function (e) {
            l(void 0, t[e], r, c, g, e, p);
          });
        }
        p.length = p.length - 1;
      }
    } else e !== t && ("number" === y && isNaN(e) && isNaN(t) || r(new n(g, e, t)));
  }
  function c(e, t, r, n) {
    return n = n || [], l(e, t, function (e) {
      e && n.push(e);
    }, r), n.length ? n : void 0;
  }
  function s(e, t, r) {
    if (r.path && r.path.length) {
      var n,
        o = e[t],
        i = r.path.length - 1;
      for (n = 0; n < i; n++) o = o[r.path[n]];
      switch (r.kind) {
        case "A":
          s(o[r.path[n]], r.index, r.item);
          break;
        case "D":
          delete o[r.path[n]];
          break;
        case "E":
        case "N":
          o[r.path[n]] = r.rhs;
      }
    } else switch (r.kind) {
      case "A":
        s(e[t], r.index, r.item);
        break;
      case "D":
        e = f(e, t);
        break;
      case "E":
      case "N":
        e[t] = r.rhs;
    }
    return e;
  }
  function d(e, t, r) {
    if (e && t && r && r.kind) {
      for (var n = e, o = -1, i = r.path ? r.path.length - 1 : 0; ++o < i;) "undefined" == typeof n[r.path[o]] && (n[r.path[o]] = "number" == typeof r.path[o] ? [] : {}), n = n[r.path[o]];
      switch (r.kind) {
        case "A":
          s(r.path ? n[r.path[o]] : n, r.index, r.item);
          break;
        case "D":
          delete n[r.path[o]];
          break;
        case "E":
        case "N":
          n[r.path[o]] = r.rhs;
      }
    }
  }
  function p(e, t, r) {
    if (r.path && r.path.length) {
      var n,
        o = e[t],
        i = r.path.length - 1;
      for (n = 0; n < i; n++) o = o[r.path[n]];
      switch (r.kind) {
        case "A":
          p(o[r.path[n]], r.index, r.item);
          break;
        case "D":
          o[r.path[n]] = r.lhs;
          break;
        case "E":
          o[r.path[n]] = r.lhs;
          break;
        case "N":
          delete o[r.path[n]];
      }
    } else switch (r.kind) {
      case "A":
        p(e[t], r.index, r.item);
        break;
      case "D":
        e[t] = r.lhs;
        break;
      case "E":
        e[t] = r.lhs;
        break;
      case "N":
        e = f(e, t);
    }
    return e;
  }
  function g(e, t, r) {
    if (e && t && r && r.kind) {
      var n,
        o,
        i = e;
      for (o = r.path.length - 1, n = 0; n < o; n++) "undefined" == typeof i[r.path[n]] && (i[r.path[n]] = {}), i = i[r.path[n]];
      switch (r.kind) {
        case "A":
          p(i[r.path[n]], r.index, r.item);
          break;
        case "D":
          i[r.path[n]] = r.lhs;
          break;
        case "E":
          i[r.path[n]] = r.lhs;
          break;
        case "N":
          delete i[r.path[n]];
      }
    }
  }
  function h(e, t, r) {
    if (e && t) {
      var n = function (n) {
        r && !r(e, t, n) || d(e, t, n);
      };
      l(e, t, n);
    }
  }
  function y(e) {
    return "color: " + F[e].color + "; font-weight: bold";
  }
  function v(e) {
    var t = e.kind,
      r = e.path,
      n = e.lhs,
      o = e.rhs,
      i = e.index,
      a = e.item;
    switch (t) {
      case "E":
        return [r.join("."), n, "→", o];
      case "N":
        return [r.join("."), o];
      case "D":
        return [r.join(".")];
      case "A":
        return [r.join(".") + "[" + i + "]", a];
      default:
        return [];
    }
  }
  function b(e, t, r, n) {
    var o = c(e, t);
    try {
      n ? r.groupCollapsed("diff") : r.group("diff");
    } catch (e) {
      r.log("diff");
    }
    o ? o.forEach(function (e) {
      var t = e.kind,
        n = v(e);
      r.log.apply(r, ["%c " + F[t].text, y(t)].concat(P(n)));
    }) : r.log("—— no diff ——");
    try {
      r.groupEnd();
    } catch (e) {
      r.log("—— diff end —— ");
    }
  }
  function m(e, t, r, n) {
    switch ("undefined" == typeof e ? "undefined" : N(e)) {
      case "object":
        return "function" == typeof e[n] ? e[n].apply(e, P(r)) : e[n];
      case "function":
        return e(t);
      default:
        return e;
    }
  }
  function w(e) {
    var t = e.timestamp,
      r = e.duration;
    return function (e, n, o) {
      var i = ["action"];
      return i.push("%c" + String(e.type)), t && i.push("%c@ " + n), r && i.push("%c(in " + o.toFixed(2) + " ms)"), i.join(" ");
    };
  }
  function x(e, t) {
    var r = t.logger,
      n = t.actionTransformer,
      o = t.titleFormatter,
      i = void 0 === o ? w(t) : o,
      a = t.collapsed,
      f = t.colors,
      u = t.level,
      l = t.diff,
      c = "undefined" == typeof t.titleFormatter;
    e.forEach(function (o, s) {
      var d = o.started,
        p = o.startedTime,
        g = o.action,
        h = o.prevState,
        y = o.error,
        v = o.took,
        w = o.nextState,
        x = e[s + 1];
      x && (w = x.prevState, v = x.started - d);
      var S = n(g),
        k = "function" == typeof a ? a(function () {
          return w;
        }, g, o) : a,
        j = D(p),
        E = f.title ? "color: " + f.title(S) + ";" : "",
        A = ["color: gray; font-weight: lighter;"];
      A.push(E), t.timestamp && A.push("color: gray; font-weight: lighter;"), t.duration && A.push("color: gray; font-weight: lighter;");
      var O = i(S, j, v);
      try {
        k ? f.title && c ? r.groupCollapsed.apply(r, ["%c " + O].concat(A)) : r.groupCollapsed(O) : f.title && c ? r.group.apply(r, ["%c " + O].concat(A)) : r.group(O);
      } catch (e) {
        r.log(O);
      }
      var N = m(u, S, [h], "prevState"),
        P = m(u, S, [S], "action"),
        C = m(u, S, [y, h], "error"),
        F = m(u, S, [w], "nextState");
      if (N) if (f.prevState) {
        var L = "color: " + f.prevState(h) + "; font-weight: bold";
        r[N]("%c prev state", L, h);
      } else r[N]("prev state", h);
      if (P) if (f.action) {
        var T = "color: " + f.action(S) + "; font-weight: bold";
        r[P]("%c action    ", T, S);
      } else r[P]("action    ", S);
      if (y && C) if (f.error) {
        var M = "color: " + f.error(y, h) + "; font-weight: bold;";
        r[C]("%c error     ", M, y);
      } else r[C]("error     ", y);
      if (F) if (f.nextState) {
        var _ = "color: " + f.nextState(w) + "; font-weight: bold";
        r[F]("%c next state", _, w);
      } else r[F]("next state", w);
      l && b(h, w, r, k);
      try {
        r.groupEnd();
      } catch (e) {
        r.log("—— log end ——");
      }
    });
  }
  function S() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      t = Object.assign({}, L, e),
      r = t.logger,
      n = t.stateTransformer,
      o = t.errorTransformer,
      i = t.predicate,
      a = t.logErrors,
      f = t.diffPredicate;
    if ("undefined" == typeof r) return function () {
      return function (e) {
        return function (t) {
          return e(t);
        };
      };
    };
    if (e.getState && e.dispatch) return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"), function () {
      return function (e) {
        return function (t) {
          return e(t);
        };
      };
    };
    var u = [];
    return function (e) {
      var r = e.getState;
      return function (e) {
        return function (l) {
          if ("function" == typeof i && !i(r, l)) return e(l);
          var c = {};
          u.push(c), c.started = O.now(), c.startedTime = new Date(), c.prevState = n(r()), c.action = l;
          var s = void 0;
          if (a) try {
            s = e(l);
          } catch (e) {
            c.error = o(e);
          } else s = e(l);
          c.took = O.now() - c.started, c.nextState = n(r());
          var d = t.diff && "function" == typeof f ? f(r, l) : t.diff;
          if (x(u, Object.assign({}, t, {
            diff: d
          })), u.length = 0, c.error) throw c.error;
          return s;
        };
      };
    };
  }
  var k,
    j,
    E = function (e, t) {
      return new Array(t + 1).join(e);
    },
    A = function (e, t) {
      return E("0", t - e.toString().length) + e;
    },
    D = function (e) {
      return A(e.getHours(), 2) + ":" + A(e.getMinutes(), 2) + ":" + A(e.getSeconds(), 2) + "." + A(e.getMilliseconds(), 3);
    },
    O = "undefined" != typeof performance && null !== performance && "function" == typeof performance.now ? performance : Date,
    N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
    P = function (e) {
      if (Array.isArray(e)) {
        for (var t = 0, r = Array(e.length); t < e.length; t++) r[t] = e[t];
        return r;
      }
      return Array.from(e);
    },
    C = [];
  k = "object" === ("undefined" == typeof commonjsGlobal ? "undefined" : N(commonjsGlobal)) && commonjsGlobal ? commonjsGlobal : "undefined" != typeof window ? window : {}, j = k.DeepDiff, j && C.push(function () {
    "undefined" != typeof j && k.DeepDiff === c && (k.DeepDiff = j, j = void 0);
  }), t(n, r), t(o, r), t(i, r), t(a, r), Object.defineProperties(c, {
    diff: {
      value: c,
      enumerable: !0
    },
    observableDiff: {
      value: l,
      enumerable: !0
    },
    applyDiff: {
      value: h,
      enumerable: !0
    },
    applyChange: {
      value: d,
      enumerable: !0
    },
    revertChange: {
      value: g,
      enumerable: !0
    },
    isConflict: {
      value: function () {
        return "undefined" != typeof j;
      },
      enumerable: !0
    },
    noConflict: {
      value: function () {
        return C && (C.forEach(function (e) {
          e();
        }), C = null), c;
      },
      enumerable: !0
    }
  });
  var F = {
      E: {
        color: "#2196F3",
        text: "CHANGED:"
      },
      N: {
        color: "#4CAF50",
        text: "ADDED:"
      },
      D: {
        color: "#F44336",
        text: "DELETED:"
      },
      A: {
        color: "#2196F3",
        text: "ARRAY:"
      }
    },
    L = {
      level: "log",
      logger: console,
      logErrors: !0,
      collapsed: void 0,
      predicate: void 0,
      duration: !1,
      timestamp: !0,
      stateTransformer: function (e) {
        return e;
      },
      actionTransformer: function (e) {
        return e;
      },
      errorTransformer: function (e) {
        return e;
      },
      colors: {
        title: function () {
          return "inherit";
        },
        prevState: function () {
          return "#9E9E9E";
        },
        action: function () {
          return "#03A9F4";
        },
        nextState: function () {
          return "#4CAF50";
        },
        error: function () {
          return "#F20404";
        }
      },
      diff: !1,
      diffPredicate: void 0,
      transformer: void 0
    },
    T = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = e.dispatch,
        r = e.getState;
      return "function" == typeof t || "function" == typeof r ? S()({
        dispatch: t,
        getState: r
      }) : void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n");
    };
  e.defaults = L, e.createLogger = S, e.logger = T, e.default = T, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});
}(reduxLogger, reduxLogger.exports));

var logger = /*@__PURE__*/getDefaultExportFromCjs(reduxLogger.exports);

function ownKeys$m(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$m(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$m(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$m(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var types = {
  SELECT_ITEM: 'EDITOR/SELECT_ITEM',
  UPDATE_MOVEITEM: 'EDITOR/UPDATE_MOVEITEM',
  TOGGLE_NEW_MODAL: 'EDITOR/TOGGLE_NEW_MODAL'
};
var actions = {
  selectItem: function selectItem(itemid) {
    return {
      type: types.SELECT_ITEM,
      payload: itemid
    };
  },
  updateMoveItem: function updateMoveItem(item) {
    return {
      type: types.UPDATE_MOVEITEM,
      payload: item
    };
  },
  toggleNewModal: function toggleNewModal(show) {
    return {
      type: types.TOGGLE_NEW_MODAL,
      payload: show
    };
  }
};
var mountPath = 'editor'; // mount point in global state, must match root reducer

var initial_state = {
  selected_itemid: null,
  move: false,
  newModalOpen: false
};
function reducer$1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial_state;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case types.SELECT_ITEM:
      {
        if (action.payload === state.selected_itemid) {
          return state;
        }
        return _objectSpread$m(_objectSpread$m({}, state), {}, {
          selected_itemid: action.payload,
          move: true
        });
      }
    case types.UPDATE_MOVEITEM:
      {
        return _objectSpread$m(_objectSpread$m({}, state), {}, {
          move: action.payload
        });
      }
    case types.TOGGLE_NEW_MODAL:
      {
        return _objectSpread$m(_objectSpread$m({}, state), {}, {
          newModalOpen: action.payload
        });
      }
    default:
      return state;
  }
}
var localSelectors = {
  selectedItemId: function selectedItemId(state) {
    return state.selected_itemid;
  },
  move: function move(state) {
    return state.move;
  }
};
var selectors = globalizeSelectors(localSelectors, mountPath);

var reducer = combineReducers({
  layout: reducer$2,
  editor: reducer$1,
  undoHistory: undoHistoryReducer
});

var middleware = applyMiddleware(logger, undoMiddleware);
var store = createStore(reducer, middleware);

var css_248z$c = ".nav__container {\r\n  background-color: #2d3e50;\r\n  width: 100%;\r\n  color: white;\r\n}\r\n\r\n.nav__splitter {\r\n  border-right: 2px white solid;\r\n}\r\n\r\n.nav__btns {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.nav__pageSettings {\r\n  display: block;\r\n}\r\n";
styleInject(css_248z$c);

var css_248z$b = "/* Styling the button */\n.btn__container {\n  font: inherit;\n  display: flex;\n  align-items: center;\n  width: 25%;\n  background: transparent;\n  border: none;\n  padding: 0.5rem;\n  color: inherit;\n  margin: 0 0.5rem;\n}\n\n/* Styling the navbar's buttons */\n.btn__container--navbar {\n  flex-direction: column;\n}\n\n.btn__container--navbar:active {\n  background-color: #5a6268;\n}\n\n/*Styling the toolbar's buttons */\n\n.btn__container--toolbar {\n  width: 90%;\n}\n\n.btn__container--toolbar:active,\n.btn__container--toolbar:hover {\n  background-color: #0069d9;\n}\n\n.btn__toolbar--clear,\n.btn__toolbar--clear:active,\n.btn__toolbar--clear:hover,\n.btn__toolbar--clear:focus {\n  background-color: #c82333;\n}\n\n/*Styling the icon */\n\n.icon {\n  color: #ffffff;\n  margin-bottom: 0.2rem;\n}\n\n.icon--toolbar {\n  margin-right: 1rem;\n  width: 1rem;\n}\n";
styleInject(css_248z$b);

var _excluded$8 = ["className", "children", "style", "active", "primary", "bordered", "disabled"];
function ownKeys$l(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$l(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$l(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$l(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Button = function Button(props) {
  /**
   * flex: 0 0 16.666667%;
   * max-width: 16.666667%;
   */

  var className = props.className,
    children = props.children,
    style = props.style;
    props.active;
    var primary = props.primary,
    bordered = props.bordered,
    disabled = props.disabled,
    rest = _objectWithoutProperties(props, _excluded$8);
  var defaultStyle = {};
  var classes = ['ep-btn', className];
  if (primary) {
    classes.push('ep-btn-primary');
  }
  if (disabled) {
    classes.push('ep-btn-disabled');
  }
  if (bordered) {
    classes.push('ep-btn-bordered');
  }
  return /*#__PURE__*/React.createElement("button", _extends({
    type: "button",
    className: classes.join(' '),
    style: _objectSpread$l(_objectSpread$l({}, defaultStyle), style)
  }, rest), children);
};
Button.propTypes = {
  children: PropTypes.any,
  style: PropTypes.object,
  primary: PropTypes.bool,
  disabled: PropTypes.bool,
  bordered: PropTypes.bool,
  active: PropTypes.bool,
  className: PropTypes.string
};
Button.defaultProps = {
  style: {},
  primary: false,
  disabled: false,
  bordered: true,
  active: false
};

var IconButton = function IconButton(props) {
  var icon = props.icon,
    iconSize = props.iconSize,
    text = props.text,
    inNavbar = props.inNavbar,
    onClick = props.onClick,
    color = props.color,
    active = props.active,
    draggable = props.draggable,
    id = props.id,
    onDragStart = props.onDragStart,
    spin = props.spin;
  var buttonStyle = classnames({
    btn__container: true,
    'btn__container--navbar': inNavbar,
    'btn__container--toolbar': !inNavbar
  });
  var iconStyle = classnames({
    icon: true,
    'icon--toolbar': !inNavbar
  });
  return /*#__PURE__*/React.createElement(Button, {
    bordered: false,
    type: "button",
    color: color,
    className: buttonStyle,
    size: "md",
    onClick: onClick,
    active: active,
    draggable: draggable,
    id: id,
    onDragStart: onDragStart,
    style: {
      backgroundColor: color === 'danger' ? '#dc3545' : 'unset'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: iconStyle
  }, icon && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "".concat(icon),
    size: iconSize,
    spin: spin
  })), text);
};
IconButton.defaultProps = {
  inNavbar: false,
  iconSize: '2x',
  text: '',
  onClick: function onClick() {},
  active: false,
  draggable: false,
  spin: false
};
IconButton.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string,
  iconSize: PropTypes.string,
  inNavbar: PropTypes.bool,
  onClick: PropTypes.func,
  color: PropTypes.string,
  active: PropTypes.bool,
  draggable: PropTypes.bool,
  id: PropTypes.string,
  onDragStart: PropTypes.func,
  spin: PropTypes.bool
};

var css_248z$a = ".pageSettings__title {\n  text-align: center;\n  font-weight: 600;\n  margin-bottom: 0;\n}\n\n.pageSettings__items {\n  display: flex;\n}\n\n.pageSettings__size {\n  width: 30%;\n}\n\n.pageSettings__margin {\n  width: 50%;\n}\n\n.pageSettings__orientation {\n  display: flex;\n  flex-direction: column;\n}\n\n.pageSettings__margin > div {\n  display: flex;\n}\n";
styleInject(css_248z$a);

var css_248z$9 = ".container {\n  color: inherit;\n}\n\n.formGroup__container--horizontal {\n  display: flex;\n  justify-content: space-around;\n}\n\n.formGroup__container--text {\n  justify-content: flex-start;\n}\n\n.formGroup__input {\n  outline: none;\n  color: inherit;\n  position: static;\n  margin-left: 0;\n}\n\n.formGroup__input:active,\n.formGroup__input:hover,\n.formGroup__input:focus {\n  color: black;\n}\n\n.formGroup__input--sm {\n  width: 30%;\n  outline: none;\n  color: inherit;\n}\n\n.formGroup__input--md {\n  width: 90%;\n  outline: none;\n  color: inherit;\n}\n\n.formGroup__container--vertical {\n  display: block;\n}\n";
styleInject(css_248z$9);

var _excluded$7 = ["className", "children", "style", "bsSize", "bordered", "disabled", "plaintext", "type", "value"];
var Input = function Input(props) {
  /**
   * flex: 0 0 16.666667%;
   * max-width: 16.666667%;
   */

  var className = props.className,
    children = props.children,
    style = props.style,
    bsSize = props.bsSize,
    bordered = props.bordered,
    disabled = props.disabled,
    plaintext = props.plaintext,
    type = props.type,
    value = props.value,
    rest = _objectWithoutProperties(props, _excluded$7);
  var classes = ['ep-input', className];
  if (bsSize === 'sm') {
    classes.push('ep-input-sm');
  }
  if (type === 'checkbox') {
    classes.push('ep-input-checkbox');
  }
  if (disabled) {
    classes.push('ep-input-disabled');
  }
  if (bordered) {
    classes.push('ep-input-bordered');
  }
  if (plaintext) {
    classes.push('ep-input-plaintext');
  }
  var value_to_show = '';
  if (value) {
    value_to_show = value;
  }
  return /*#__PURE__*/React.createElement("input", _extends({
    type: type,
    value: value_to_show,
    className: classes.join(' '),
    style: style
  }, rest), children);
};
Input.propTypes = {
  children: PropTypes.any,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  bordered: PropTypes.bool,
  plaintext: PropTypes.bool,
  className: PropTypes.string,
  type: PropTypes.string,
  bsSize: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Input.defaultProps = {
  type: 'text',
  style: {},
  disabled: false,
  bordered: true,
  plaintext: false
};

var customInput = function customInput(props) {
  var type = props.type,
    labelText = props.labelText,
    variant = props.variant,
    modifier = props.modifier,
    plainText = props.plainText,
    inputSize = props.inputSize,
    onChange = props.onChange,
    value = props.value,
    min = props.min,
    checked = props.checked,
    placeHolder = props.placeHolder,
    disabled = props.disabled,
    width = props.width;
  var formGroupStyle = classnames({
    formGroup__container: true,
    'formGroup__container--horizontal': variant === 'horizontal',
    'formGroup__container--text': modifier === 'typeSettings',
    'formGroup__container--vertical': variant === 'vertical'
  });
  return /*#__PURE__*/React.createElement("div", {
    className: formGroupStyle,
    style: {
      margin: 0,
      width: width || 'unset'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "formGroup__label"
  }, "".concat(labelText)), /*#__PURE__*/React.createElement(Input, {
    disabled: disabled,
    checked: checked,
    min: min,
    value: value,
    placeholder: placeHolder,
    onChange: onChange,
    type: type,
    className: "formGroup__input formGroup__input--".concat(inputSize),
    id: "label".concat(labelText),
    bsSize: inputSize,
    plaintext: plainText
  }));
};
customInput.defaultProps = {
  type: '',
  inputSize: 'sm',
  plainText: false,
  variant: 'horizontal',
  labelText: '',
  onChange: function onChange() {},
  min: ''
};
customInput.propTypes = {
  type: PropTypes.string,
  checked: PropTypes.bool,
  labelText: PropTypes.string,
  min: PropTypes.string,
  plainText: PropTypes.bool,
  placeHolder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inputSize: PropTypes.string,
  variant: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  modifier: PropTypes.string
};

/* eslint-disable quotes */
/**
 * Allows downlaoding the given data as a file
 * @param {*} filename
 * @param {*} data
 */

// Declare the size of grid block
var gridSize = 15;

// Calculate the number of squares for Editor stage
var gridGenerate = function gridGenerate(width, height, gridSize) {
  var grid = {
    widthLines: [],
    heightLines: []
  };
  for (var i = 0; i < width / gridSize; i++) {
    grid.widthLines.push(/*#__PURE__*/React.createElement(Line, {
      key: "line_width_".concat(i),
      points: [Math.round(i * gridSize) + 0.5, 0, Math.round(i * gridSize) + 0.5, height],
      stroke: "#ddd",
      strokeWidth: 1
    }));
  }
  for (var j = 0; j < height / gridSize; j++) {
    grid.heightLines.push(/*#__PURE__*/React.createElement(Line, {
      key: "line_height_".concat(j),
      points: [0, Math.round(j * gridSize), width, Math.round(j * gridSize)],
      stroke: "#ddd",
      strokeWidth: 1
    }));
  }
  return grid;
};

// Declare dragBound for item in editor panel
var dragBoundItem = function dragBoundItem(pos, layout, item, rotation) {
  var edgeBound = {
    left: 5,
    top: 5,
    right: layout.width.pixel - layout.marginRight - layout.marginLeft - 5,
    bottom: layout.height.pixel - layout.marginTop - layout.marginBottom
  };
  switch (rotation) {
    case 90:
      edgeBound.left += item.height;
      edgeBound.bottom -= item.width;
      break;
    case 180:
      edgeBound.left += item.width;
      edgeBound.top += item.height;
      break;
    case 270:
      edgeBound.right -= item.height;
      edgeBound.top += item.width;
      break;
    default:
      edgeBound.right -= item.width;
      edgeBound.bottom -= item.height;
      break;
  }
  var newX = pos.x < edgeBound.left ? edgeBound.left : pos.x > edgeBound.right ? edgeBound.right : pos.x;
  var newY = pos.y < edgeBound.top ? edgeBound.top : pos.y > edgeBound.bottom ? edgeBound.bottom : pos.y;
  return {
    x: newX,
    y: newY
  };
};
function download(filename, data) {
  var blob = new Blob([JSON.stringify(data)], {
    type: 'text/csv'
  });
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveBlob(blob, filename);
  } else {
    var elem = window.document.createElement('a');
    elem.href = window.URL.createObjectURL(blob);
    elem.download = filename + '.json';
    document.body.appendChild(elem);
    elem.click();
    document.body.removeChild(elem);
  }
}

/**
 *  Printing image
 */

function ImagetoPrint(source) {
  // Maybe also scale the image and page size to label size?
  return '<html><head><script>function step1(){\n' + "setTimeout('step2()', 10);}\n" + 'function step2(){window.print();window.close()}\n' + "</script></head><body onload='step1()'>\n" + "<img src='" + source + "' /></body></html>";
}
function PrintImage(source, labeljson, printername, copies) {
  if (window.qtside) {
    // Only need the labeldata as JSON on QtSide
    // File it_pos_app/Printer.py handles this call!
    window.qtside.printer.printLabel(labeljson, printername, copies);
  } else {
    var Pagelink = 'about:blank';
    var pwa = window.open(Pagelink, '_new');
    pwa.document.open();
    pwa.document.write(ImagetoPrint(source));
    pwa.document.close();
  }
}

/*converting pixels to mm and mm to pixels for page settings*/
var DPI = getDPI();
function mmToPixel(mm) {
  return Math.round(mm * DPI / 25.4);
}
function pixelToMm(pixel) {
  return Math.round(pixel * 25.4 / DPI);
}
function getDPI() {
  return document.getElementById('dpi') && document.getElementById('dpi').offsetHeight;
}

var _excluded$6 = ["className", "children", "style"];
function ownKeys$k(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$k(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$k(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$k(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Row = function Row(props) {
  var className = props.className,
    children = props.children,
    style = props.style,
    rest = _objectWithoutProperties(props, _excluded$6);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: className,
    style: _objectSpread$k({
      display: 'flex',
      flexWrap: 'wrap',
      margin: 0
    }, style)
  }, rest), children);
};
Row.propTypes = {
  children: PropTypes.any,
  style: PropTypes.object,
  className: PropTypes.string
};

var _excluded$5 = ["className", "children", "style", "xs"];
function ownKeys$j(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$j(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$j(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$j(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Col = function Col(props) {
  /**
   * flex: 0 0 16.666667%;
   * max-width: 16.666667%;
   */

  var className = props.className,
    children = props.children,
    style = props.style,
    xs = props.xs,
    rest = _objectWithoutProperties(props, _excluded$5);
  var width;
  var flex;
  var maxWidth;
  if (xs === 'auto') {
    width = 'auto';
    flex = ' 0 0 auto';
    maxWidth = '100%';
  } else if (xs) {
    width = (100 * (xs / 12)).toString() + '%';
    maxWidth = width;
    flex = width;
  } else {
    maxWidth = '100%';
    width = null;
  }
  return /*#__PURE__*/React.createElement("div", _extends({
    className: className,
    style: _objectSpread$j({
      flex: flex,
      width: width,
      maxWidth: maxWidth,
      paddingTop: '0',
      paddingBottom: '0',
      paddingLeft: '15px',
      paddingRight: '15px',
      flexBasis: 0,
      flexGrow: 1
    }, style)
  }, rest), children);
};
Col.propTypes = {
  xs: PropTypes.any,
  children: PropTypes.any,
  style: PropTypes.object,
  className: PropTypes.string
};
Col.defaultProps = {
  style: {}
};

function ownKeys$i(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$i(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$i(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$i(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$i(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$i() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$i() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$i = function _isNativeReflectConstruct() { return !!t; })(); }
var PageSettings = /*#__PURE__*/function (_Component) {
  function PageSettings() {
    var _this;
    _classCallCheck(this, PageSettings);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$i(this, PageSettings, [].concat(args));
    _defineProperty(_this, "customWidth", function (e) {
      var num = Number(e.target.value);
      if (!isNaN(num)) {
        num = {
          pixel: mmToPixel(num),
          mm: num
        };
        var value = _objectSpread$i(_objectSpread$i({}, _this.props.layout), {}, {
          width: num
        });
        _this.props.updatePage(value);
      }
    });
    _defineProperty(_this, "customHeight", function (e) {
      var num = Number(e.target.value);
      if (!isNaN(num)) {
        num = {
          pixel: mmToPixel(num),
          mm: num
        };
        var value = _objectSpread$i(_objectSpread$i({}, _this.props.layout), {}, {
          height: num
        });
        _this.props.updatePage(value);
      }
    });
    _defineProperty(_this, "customMarginTop", function (e) {
      var num = Number(e.target.value);
      if (!isNaN(num)) {
        num = mmToPixel(num);
        var value = _objectSpread$i(_objectSpread$i({}, _this.props.layout), {}, {
          marginTop: num
        });
        _this.props.updatePage(value);
      }
    });
    _defineProperty(_this, "customMarginBottom", function (e) {
      var num = Number(e.target.value);
      if (!isNaN(num)) {
        num = mmToPixel(num);
        var value = _objectSpread$i(_objectSpread$i({}, _this.props.layout.width), {}, {
          marginBottom: num
        });
        _this.props.updatePage(value);
      }
    });
    _defineProperty(_this, "customMarginLeft", function (e) {
      var num = Number(e.target.value);
      if (!isNaN(num)) {
        num = mmToPixel(num);
        var value = _objectSpread$i(_objectSpread$i({}, _this.props.layout.width), {}, {
          marginLeft: num
        });
        _this.props.updatePage(value);
      }
    });
    _defineProperty(_this, "customMarginRight", function (e) {
      var num = Number(e.target.value);
      if (!isNaN(num)) {
        num = mmToPixel(num);
        var value = _objectSpread$i(_objectSpread$i({}, _this.props.layout.width), {}, {
          marginRight: num
        });
        _this.props.updatePage(value);
      }
    });
    _defineProperty(_this, "setOrientation", function (value) {
      switch (value) {
        case ORIENTATION_LANDSCAPE:
          _this.props.setOrientation(ORIENTATION_LANDSCAPE);
          break;
        case ORIENTATION_PORTRAIT:
          _this.props.setOrientation(ORIENTATION_PORTRAIT);
          break;
      }
    });
    return _this;
  }
  _inherits(PageSettings, _Component);
  return _createClass(PageSettings, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this$props$layout = this.props.layout,
        width = _this$props$layout.width,
        height = _this$props$layout.height,
        marginTop = _this$props$layout.marginTop,
        marginBottom = _this$props$layout.marginBottom,
        marginLeft = _this$props$layout.marginLeft,
        marginRight = _this$props$layout.marginRight,
        orientation = _this$props$layout.orientation;
      if (width !== nextProps.layout.width || height !== nextProps.layout.height || marginTop !== nextProps.layout.marginTop || marginBottom !== nextProps.layout.marginBottom || marginLeft !== nextProps.layout.marginLeft || marginRight !== nextProps.layout.marginRight || orientation !== nextProps.layout.orientation) {
        return true;
      }
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var t = this.props.t;
      var _this$props$layout2 = this.props.layout,
        width = _this$props$layout2.width,
        height = _this$props$layout2.height,
        marginTop = _this$props$layout2.marginTop,
        marginBottom = _this$props$layout2.marginBottom,
        marginLeft = _this$props$layout2.marginLeft,
        marginRight = _this$props$layout2.marginRight;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
        className: "pageSettings__title margin-0"
      }, t('lbl.pageSettings', 'Page settings')), /*#__PURE__*/React.createElement("div", {
        className: "pageSettings__items"
      }, /*#__PURE__*/React.createElement("div", {
        className: "pageSettings__size"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        className: "margin-0"
      }, t('lbl.sizes.colon', 'Sizes:')), /*#__PURE__*/React.createElement(customInput, {
        type: "number",
        min: "0",
        value: pixelToMm(width.pixel) === 0 ? '' : pixelToMm(width.pixel),
        labelText: "".concat(t('lbl.width', 'Width'), " [mm]"),
        onChange: this.customWidth,
        plainText: true
      }), /*#__PURE__*/React.createElement(customInput, {
        type: "number",
        min: "0",
        value: pixelToMm(height.pixel) === 0 ? '' : pixelToMm(height.pixel),
        labelText: "".concat(t('lbl.height', 'Height'), " [mm]"),
        onChange: this.customHeight,
        plainText: true
      }))), /*#__PURE__*/React.createElement("div", {
        className: "pageSettings__margin"
      }, /*#__PURE__*/React.createElement("p", {
        className: "margin-0"
      }, t('lbl.margins.colon', 'Margins:')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(customInput, {
        type: "number",
        min: "0",
        value: pixelToMm(marginTop) === 0 ? '' : pixelToMm(marginTop),
        placeholder: 0,
        labelText: "".concat(t('lbl.topMargin', 'Top'), " [mm]"),
        onChange: this.customMarginTop,
        plainText: true
      }), /*#__PURE__*/React.createElement(customInput, {
        type: "number",
        min: "0",
        placeholder: 0,
        value: pixelToMm(marginLeft) === 0 ? '' : pixelToMm(marginLeft),
        labelText: "".concat(t('lbl.leftMargin', 'Left'), " [mm]"),
        onChange: this.customMarginLeft,
        plainText: true
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(customInput, {
        type: "number",
        min: "0",
        placeholder: 0,
        value: pixelToMm(marginBottom) === 0 ? '' : pixelToMm(marginBottom),
        labelText: "".concat(t('lbl.bottomMargin', 'Bottom'), " [mm]"),
        onChange: this.customMarginBottom,
        plainText: true
      }), /*#__PURE__*/React.createElement(customInput, {
        type: "number",
        min: "0",
        placeholder: 0,
        value: pixelToMm(marginRight) === 0 ? '' : pixelToMm(marginRight),
        labelText: "".concat(t('lbl.rightMargin', 'Right'), " [mm]"),
        onChange: this.customMarginRight,
        plainText: true
      })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, {
        style: {
          margin: 0
        }
      }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
        className: "margin-0"
      }, t('lbl.orientation.colon', 'Orientation:')))), /*#__PURE__*/React.createElement(Row, {
        style: {
          margin: 0
        }
      }, /*#__PURE__*/React.createElement(Col, {
        style: {
          padding: 0,
          display: 'flex',
          justifyContent: 'space-around'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return _this2.setOrientation(ORIENTATION_LANDSCAPE);
        },
        primary: this.props.layout.orientation === ORIENTATION_LANDSCAPE
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: 'image'
      })), /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return _this2.setOrientation(ORIENTATION_PORTRAIT);
        },
        primary: this.props.layout.orientation === ORIENTATION_PORTRAIT
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: 'image-portrait'
      })))))));
    }
  }]);
}(Component);
PageSettings.propTypes = {
  t: PropTypes.func.isRequired,
  layout: PropTypes.object,
  updatePage: PropTypes.func,
  setOrientation: PropTypes.func,
  classes: PropTypes.object
};
var mapStateToProps$4 = function mapStateToProps(state) {
  return {
    layout: state.layout
  };
};
var mapDispatchToProps$4 = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    updatePage: actions$1.updatePage,
    setOrientation: actions$1.setOrientation
  }, dispatch);
};
var PageSettings$1 = withTranslation('translations')(connect(mapStateToProps$4, mapDispatchToProps$4)(PageSettings));

var css_248z$8 = ".saveModal__input {\r\n  width: 50%;\r\n}\r\n";
styleInject(css_248z$8);

var Modal = function Modal(props) {
  /**
   * flex: 0 0 16.666667%;
   * max-width: 16.666667%;
   */

  var isOpen = props.isOpen,
    children = props.children;
  if (!isOpen) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "ep-modal-backdrop"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ep-modal-dialog"
  }, children));
};
Modal.propTypes = {
  children: PropTypes.any,
  isOpen: PropTypes.bool
};
Modal.defaultProps = {
  isOpen: false
};

var ModalHeader = function ModalHeader(props) {
  /**
   * flex: 0 0 16.666667%;
   * max-width: 16.666667%;
   */

  var children = props.children,
    style = props.style;
  return /*#__PURE__*/React.createElement("div", {
    className: "ep-modal-header",
    style: style
  }, /*#__PURE__*/React.createElement("h5", null, " ", children));
};
ModalHeader.propTypes = {
  children: PropTypes.any,
  style: PropTypes.object
};
ModalHeader.defaultProps = {
  style: {}
};

var ModalBody = function ModalBody(props) {
  /**
   * flex: 0 0 16.666667%;
   * max-width: 16.666667%;
   */

  var children = props.children,
    style = props.style;
  return /*#__PURE__*/React.createElement("div", {
    className: "ep-modal-body",
    style: style
  }, children);
};
ModalBody.propTypes = {
  children: PropTypes.any,
  style: PropTypes.object
};
ModalBody.defaultProps = {
  style: {}
};

var ModalFooter = function ModalFooter(props) {
  /**
   * flex: 0 0 16.666667%;
   * max-width: 16.666667%;
   */

  var children = props.children,
    style = props.style;
  return /*#__PURE__*/React.createElement("div", {
    className: "ep-modal-footer",
    style: style
  }, children);
};
ModalFooter.propTypes = {
  children: PropTypes.any,
  style: PropTypes.object
};
ModalFooter.defaultProps = {
  style: {}
};

var SaveModal = function SaveModal(props) {
  var showSaveModal = props.showSaveModal,
    toggleSaveModal = props.toggleSaveModal,
    fileName = props.fileName,
    handleFileNameChange = props.handleFileNameChange,
    saveType = props.saveType,
    handleSaveDB = props.handleSaveDB,
    t = props.t;
  var save = function save(type) {
    if (type === 'PC') {
      download(fileName, props.layout);
      toggleSaveModal();
    } else {
      handleSaveDB(fileName, props.layout);
      toggleSaveModal();
    }
  };
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: showSaveModal
  }, /*#__PURE__*/React.createElement(ModalHeader, null, saveType === 'PC' ? t('prompt.enterFileName', 'Enter file name') : t('prompt.enterLabelName', 'Enter label name')), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(Input, {
    value: fileName,
    onChange: function onChange(e) {
      return handleFileNameChange(e);
    },
    className: "saveModal__input"
  })), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    "data-cy": "fn.save",
    primary: true,
    onClick: function onClick() {
      return save(saveType);
    },
    disabled: !fileName
  }, t('fn.save', 'Save')), /*#__PURE__*/React.createElement(Button, {
    "data-cy": "fn.cancel",
    onClick: toggleSaveModal
  }, t('fn.cancel', 'Cancel'))));
};
SaveModal.propTypes = {
  showSaveModal: PropTypes.bool,
  toggleSaveModal: PropTypes.func,
  fileName: PropTypes.string,
  saveType: PropTypes.string,
  handleFileNameChange: PropTypes.func,
  handleSaveDB: PropTypes.func,
  saveToPC: PropTypes.func,
  t: PropTypes.func,
  layout: PropTypes.object
};
var SaveModal$1 = withTranslation('translations')(SaveModal);

var css_248z$7 = ".p-0 {\n  padding: 0\n}\n\n.modalRow {\n  margin: 0 0 0.5rem;\n  padding: 0.5rem;\n  border-bottom: 1px solid #dee2e6;\n}\n\n\n.emptyLabel {\n  height: 100px;\n  text-align: center;\n  line-height: 100px;\n}\n";
styleInject(css_248z$7);

function _callSuper$h(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$h() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$h() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$h = function _isNativeReflectConstruct() { return !!t; })(); }
var AddTransformer = /*#__PURE__*/function (_React$Component) {
  function AddTransformer() {
    var _this;
    _classCallCheck(this, AddTransformer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$h(this, AddTransformer, [].concat(args));
    _defineProperty(_this, "checkNode", function () {
      var stage = _this.transformer.getStage();
      var selectedShapeName = _this.props.selectedShapeName;
      var selectedNode = stage.findOne('.' + selectedShapeName);
      if (selectedNode === _this.transformer.node()) {
        return;
      }
      if (selectedNode) {
        _this.transformer.attachTo(selectedNode);
      } else {
        _this.transformer.detach();
      }
      _this.transformer.getLayer().batchDraw();
    });
    return _this;
  }
  _inherits(AddTransformer, _React$Component);
  return _createClass(AddTransformer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkNode();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.checkNode();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/React.createElement(Transformer, {
        rotateEnabled: false,
        ref: function ref(node) {
          _this2.transformer = node;
        }
      });
    }
  }]);
}(React.Component);
AddTransformer.propTypes = {
  selectedShapeName: PropTypes.string
};

function ownKeys$h(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$h(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$h(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$h(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$g(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$g() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$g() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$g = function _isNativeReflectConstruct() { return !!t; })(); }
var Write = /*#__PURE__*/function (_React$Component) {
  function Write() {
    var _this;
    _classCallCheck(this, Write);
    _this = _callSuper$g(this, Write);
    _defineProperty(_this, "dragBound", function (pos, rotation) {
      var _dragBoundItem = dragBoundItem(pos, _this.props.layout, _this.props.item, rotation),
        x = _dragBoundItem.x,
        y = _dragBoundItem.y;
      return {
        x: x,
        y: y
      };
    });
    _defineProperty(_this, "handleClickOutside", function () {
      if (_this.inputRef) {
        _this.setState(_objectSpread$h(_objectSpread$h({}, _this.state), {}, {
          textEditVisible: false
        }));
      }
    });
    _defineProperty(_this, "renderEditor", function (event) {
      if (_this.props.readonly) {
        return;
      }
      // at first lets find position of text node relative to the stage:
      var textPosition = event.target.getAbsolutePosition();
      var stageBox = _this.shapeRef.current.parent.parent.container().getBoundingClientRect();
      var areaPosition = {
        x: stageBox.left + textPosition.x,
        y: stageBox.top + textPosition.y
      };

      // create textarea and style it
      var textarea = document.createElement('textarea');
      document.getElementById('ep_editor_container').appendChild(textarea);
      textarea.value = event.target.attrs.text;
      textarea.style.position = 'fixed';
      textarea.style.top = areaPosition.y + 'px';
      textarea.style.left = areaPosition.x + 'px';
      textarea.style.width = event.target.width();
      textarea.focus();
      textarea.addEventListener('keydown', function (e) {
        // hide on enter
        if (e.keyCode === 13) {
          _this.props.updateItem(_objectSpread$h(_objectSpread$h({}, _this.props.item), {}, {
            text: textarea.value
          }));
          document.getElementById('ep_editor_container').removeChild(textarea);
        }
      });
      textarea.addEventListener('focusout', function () {
        // hide on focus lost
        _this.props.updateItem(_objectSpread$h(_objectSpread$h({}, _this.props.item), {}, {
          text: textarea.value
        }));
        document.getElementById('ep_editor_container').removeChild(textarea);
      });
    });
    _this.state = {
      isDragging: false,
      x: 0,
      y: 0,
      textEditVisible: false,
      textValue: ''
    };
    _this.shapeRef = /*#__PURE__*/React.createRef();
    _this.trRef = /*#__PURE__*/React.createRef();
    _this.inputRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  _inherits(Write, _React$Component);
  return _createClass(Write, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState(_objectSpread$h(_objectSpread$h({}, this.state), {}, {
        x: this.props.item.x,
        y: this.props.item.y,
        textValue: this.props.item.text
      }));
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        item = _this$props.item,
        move = _this$props.move,
        selectedItemId = _this$props.selectedItemId,
        readonly = _this$props.readonly,
        selectItem = _this$props.selectItem,
        updateItem = _this$props.updateItem;
      var name = 'write' + item.id;
      var isSelected = item.id === selectedItemId;
      return /*#__PURE__*/React.createElement(React.Fragment, null, isSelected && !readonly && /*#__PURE__*/React.createElement(Rect, {
        x: item.x - 2,
        y: item.y - 2,
        width: item.width + 4,
        height: item.height + 4,
        stroke: '#99EEFF88',
        strokeWidth: 2,
        shadowBlur: 10,
        shadowOffset: {
          x: 5,
          y: 5
        },
        shadowOpacity: 0.5,
        rotation: item.rotation
      }), item.customText && !item.text && /*#__PURE__*/React.createElement(Text, {
        text: "(Double click to edit)",
        x: item.x + (item.width / 2 - 45) // Center of parent item!
        ,
        y: item.y + item.height,
        fill: '#FF6347',
        fontSize: 8,
        align: "center",
        verticalAlign: "top",
        width: 90,
        height: 12
      }), /*#__PURE__*/React.createElement(Text, {
        text: item.text ? item.text : item.prompt,
        ref: this.shapeRef,
        x: item.x,
        id: 'id_' + item.id,
        y: item.y,
        fill: item.text ? 'black' : '#FF6347',
        name: name,
        fontSize: item.fontSize,
        align: item.align,
        verticalAlign: item.verticalAlign,
        width: item.width,
        height: item.height,
        fontStyle: item.fontStyle,
        textDecoration: item.textDecoration,
        rotation: item.rotation,
        draggable: move && selectedItemId === item.id,
        fontFamily: item.fontFamily,
        dragBoundFunc: function dragBoundFunc(pos) {
          return _this2.dragBound(pos, Number(item.rotation));
        },
        onClick: readonly ? null : function () {
          return selectItem(item.id);
        },
        onDragStart: function onDragStart() {
          _this2.setState({
            isDragging: true
          });
        },
        onDragEnd: function onDragEnd(e) {
          var x = Math.round(e.target.x() / gridSize) * gridSize;
          var y = Math.round(e.target.y() / gridSize) * gridSize;
          _this2.shapeRef.current.position({
            x: x,
            y: y
          });
          updateItem(_objectSpread$h(_objectSpread$h({}, item), {}, {
            x: x,
            y: y
          }));
        },
        onTransformEnd: function onTransformEnd() {
          // transformer is changing scale
          var node = _this2.shapeRef.current;
          var scaleX = node.scaleX();
          var scaleY = node.scaleY();

          // we will reset it back
          node.scaleX(1);
          node.scaleY(1);
          updateItem(_objectSpread$h(_objectSpread$h({}, item), {}, {
            x: node.x(),
            y: node.y(),
            width: node.width() * scaleX,
            height: node.height() * scaleY
          }));
        },
        onDblClick: this.renderEditor
      }), readonly || !move ? null : /*#__PURE__*/React.createElement(AddTransformer, {
        ref: this.trRef,
        selectedShapeName: isSelected ? name : null
      }));
    }
  }]);
}(React.Component);
Write.propTypes = {
  readonly: PropTypes.bool,
  item: PropTypes.object,
  selectedItemId: PropTypes.number,
  selectItem: PropTypes.func,
  updateItem: PropTypes.func,
  layout: PropTypes.object,
  standAlone: PropTypes.bool,
  zIndex: PropTypes.string,
  move: PropTypes.bool
};
Write.defaultProps = {
  readonly: false,
  standAlone: false,
  zIndex: '0',
  move: false
};

function ownKeys$g(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$g(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$g(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$g(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$f(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$f() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$f() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$f = function _isNativeReflectConstruct() { return !!t; })(); }
var Rectangle = /*#__PURE__*/function (_React$Component) {
  function Rectangle() {
    var _this;
    _classCallCheck(this, Rectangle);
    _this = _callSuper$f(this, Rectangle);
    _defineProperty(_this, "dragBound", function (pos) {
      var _dragBoundItem = dragBoundItem(pos, _this.props.layout, _this.props.item),
        x = _dragBoundItem.x,
        y = _dragBoundItem.y;
      return {
        x: x,
        y: y
      };
    });
    _this.shapeRef = /*#__PURE__*/React.createRef();
    _this.trRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  _inherits(Rectangle, _React$Component);
  return _createClass(Rectangle, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        item = _this$props.item,
        move = _this$props.move,
        selectedItemId = _this$props.selectedItemId,
        readonly = _this$props.readonly,
        selectItem = _this$props.selectItem,
        updateItem = _this$props.updateItem;
      var name = 'rectangle' + item.id;
      var isSelected = item.id === selectedItemId;
      return /*#__PURE__*/React.createElement(React.Fragment, null, isSelected && !readonly && /*#__PURE__*/React.createElement(Rect, {
        x: item.x - 2,
        y: item.y - 2,
        width: item.width + 4,
        height: item.height + 4,
        rotation: item.rotation,
        stroke: '#99EEFF88',
        strokeWidth: 2,
        shadowBlur: 10,
        shadowOffset: {
          x: 5,
          y: 5
        },
        shadowOpacity: 0.5
      }), /*#__PURE__*/React.createElement(Rect, {
        name: name,
        ref: this.shapeRef,
        x: item.x,
        y: item.y,
        width: item.width,
        height: item.height,
        rotation: item.rotation,
        stroke: 'black',
        strokeWidth: item.strokeWidth,
        dragBoundFunc: this.dragBound,
        cornerRadius: item.cornerRadius,
        draggable: move && selectedItemId === item.id,
        onClick: readonly ? null : function () {
          return selectItem(item.id);
        },
        onTransformEnd: function onTransformEnd(e) {
          // transformer is changing scale
          var node = _this2.shapeRef.current;
          var scaleX = node.scaleX();
          var scaleY = node.scaleY();

          // we will reset it back
          node.scaleX(1);
          node.scaleY(1);
          updateItem(_objectSpread$g(_objectSpread$g({}, item), {}, {
            x: node.x(),
            y: node.y(),
            width: node.width() * scaleX,
            height: node.height() * scaleY
          }));
        },
        onDragEnd: function onDragEnd(e) {
          var x = Math.round(e.target.x() / gridSize) * gridSize;
          var y = Math.round(e.target.y() / gridSize) * gridSize;
          _this2.shapeRef.current.position({
            x: x,
            y: y
          });
          updateItem(_objectSpread$g(_objectSpread$g({}, item), {}, {
            x: x,
            y: y
          }));
        }
      }), readonly || !move ? null : /*#__PURE__*/React.createElement(AddTransformer, {
        ref: this.trRef,
        selectedShapeName: isSelected ? name : null
      }));
    }
  }]);
}(React.Component);
Rectangle.propTypes = {
  readonly: PropTypes.bool,
  move: PropTypes.bool,
  selectItem: PropTypes.func.isRequired,
  updateItem: PropTypes.func.isRequired,
  item: PropTypes.object,
  selectedItemId: PropTypes.number,
  layout: PropTypes.object
};
Rectangle.defaultProps = {
  readonly: false,
  selectItem: function selectItem() {},
  updateItem: function updateItem() {}
};

// Item types

var ITEM_TEXT = 'text';
var ITEM_VARIABLE = 'variable';
var ITEM_BARCODE = 'barcode';
var ITEM_RECTANGLE = 'rectangle';
var ITEM_ELLIPSE = 'ellipse';
var ITEM_LINE = 'line';
var ITEM_IMAGE = 'image';

// Barcode types

var BARCODE_EAN8 = 'ean8';
var BARCODE_EAN13 = 'ean13';
var BARCODE_CODE39 = 'code39';
var BARCODE_CODE128 = 'code128';
var BARCODE_UPCA = 'upca';
var BARCODE_GS_128 = 'gs1-128';
var BARCODE_QRCODE = 'qrcode';
var BARCODE_DATABAR_STACKED = 'databarexpandedstacked';

// Length of fixed length barcode types.
// Also enables check digit computation for these types.
var BARCODELENGTH = _defineProperty(_defineProperty(_defineProperty({}, BARCODE_EAN8, 8), BARCODE_UPCA, 12), BARCODE_EAN13, 13);

function ownKeys$f(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$f(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$f(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$f(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$e(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$e() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$e() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$e = function _isNativeReflectConstruct() { return !!t; })(); }
var DUMMY_BARCODE_CODE = {
  ean13: '978020137962',
  ean8: '9031101',
  code39: 'ABC-1234',
  ean14: '',
  upca: '72527273070',
  isbn: '9781234567897',
  issn: '9771234567898',
  pzn: '',
  itf14: '',
  code128: 'ABC-abc-1234',
  'gs1-128': '(01)12345678901231',
  'gs-128': '(01)12345678901231',
  qrcode: 'This is a QR Code',
  datamatrix: 'This is a Data Matrix',
  databarstacked: '(01)2401234567890',
  databarexpandedstacked: '(01)12345678901231(3202)123456(15)120202'
};
var Barcode = /*#__PURE__*/function (_React$Component) {
  function Barcode(props) {
    var _this;
    _classCallCheck(this, Barcode);
    _this = _callSuper$e(this, Barcode, [props]);
    _defineProperty(_this, "dragBound", function (pos, rotation) {
      var _dragBoundItem = dragBoundItem(pos, _this.props.layout, _this.props.item, rotation),
        x = _dragBoundItem.x,
        y = _dragBoundItem.y;
      return {
        x: x,
        y: y
      };
    });
    _this.state = {
      gsucc: true,
      barcodecanvas: '',
      options: {
        bcid: BARCODE_EAN13,
        // Barcode type code39
        text: DUMMY_BARCODE_CODE.ean13,
        // Text to encode 978020137962
        scale: 3,
        // 3x scaling factor
        height: 10,
        // Bar height, in millimeters
        includetext: false,
        // Show human-readable text
        textxalign: 'center',
        // Always good to set this

        dontlint: true
      }
    };
    _this.shapeRef = /*#__PURE__*/React.createRef();
    _this.trRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  //Set the correct state based on Store's props
  _inherits(Barcode, _React$Component);
  return _createClass(Barcode, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var canvas = document.createElement('canvas');
      try {
        // The return value is the canvas element
        if (this.state.options.text) {
          var rs = bwipjs.toCanvas(canvas, this.state.options);
          this.setState(_objectSpread$f(_objectSpread$f({}, this.state), {}, {
            barcodecanvas: rs,
            gsucc: true
          }));
        } else {
          this.setState({
            gsucc: false,
            barcodecanvas: ''
          });
        }
      } catch (e) {
        // `e` may be a string or Error object
        console.log(e);
        this.setState({
          gsucc: false,
          barcodecanvas: ''
        });
      }
      /*barcodePromise(canvas, this.state.options)
        .then(() => {
          this.setState({
            //...item,
            ...this.state,
            barcodecanvas: canvas,
            gsucc: true,
          });
        })
        .catch((err) => {
          // console.log(err);
          // Barcode generation failed. Let user know
          this.setState({
            gsucc: false,
            barcodecanvas: '',
          });
        });*/
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      var _this2 = this;
      var canvas = document.createElement('canvas');
      if (prevState.options.text !== this.state.options.text || prevState.options.bcid !== this.state.options.bcid) {
        this.setState(_objectSpread$f(_objectSpread$f({}, this.state), {}, {
          options: _objectSpread$f(_objectSpread$f({}, this.state.options), {}, {
            text: this.state.options.text,
            bcid: this.state.options.bcid
          })
        }), function () {
          try {
            // The return value is the canvas element
            if (_this2.state.options.text) {
              var rs = bwipjs.toCanvas(canvas, _objectSpread$f(_objectSpread$f({}, _this2.state.options), {}, {
                includetext: false
              }));
              _this2.setState(_objectSpread$f(_objectSpread$f({}, _this2.state), {}, {
                barcodecanvas: rs,
                gsucc: true
              }));
            } else {
              _this2.setState({
                gsucc: false,
                barcodecanvas: ''
              });
            }
          } catch (e) {
            // `e` may be a string or Error object
            console.log(e);
            _this2.setState({
              gsucc: false,
              barcodecanvas: ''
            });
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        item = _this$props.item,
        move = _this$props.move,
        selectedItemId = _this$props.selectedItemId,
        readonly = _this$props.readonly,
        selectItem = _this$props.selectItem,
        updateItem = _this$props.updateItem;
      var name = 'barcode' + item.id;
      var isSelected = item.id === this.props.selectedItemId;
      return /*#__PURE__*/React.createElement(React.Fragment, null, isSelected && !readonly && /*#__PURE__*/React.createElement(Rect, {
        x: item.x - 2,
        y: item.y - 2,
        width: item.width + 4,
        height: item.height + 4,
        stroke: '#99EEFF88',
        strokeWidth: 2,
        shadowBlur: 10,
        shadowOffset: {
          x: 5,
          y: 5
        },
        shadowOpacity: 0.5,
        rotation: item.rotation
      }), this.state.gsucc ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Image, {
        name: name,
        ref: this.shapeRef,
        x: item.x,
        y: item.y,
        image: this.state.barcodecanvas,
        width: item.width,
        height: item.height,
        rotation: item.rotation,
        draggable: move && selectedItemId === item.id
        //fill={this.state.isDragging ? 'green' : 'black'}
        ,
        dragBoundFunc: function dragBoundFunc(pos) {
          return _this3.dragBound(pos, Number(item.rotation));
        },
        onClick: readonly ? null : function () {
          return selectItem(item.id);
        },
        onTransformEnd: function onTransformEnd(e) {
          // transformer is changing scale
          var node = _this3.shapeRef.current;
          var scaleX = node.scaleX();
          var scaleY = node.scaleY();
          // we will reset it back
          node.scaleX(1);
          node.scaleY(1);
          updateItem(_objectSpread$f(_objectSpread$f({}, item), {}, {
            x: node.x(),
            y: node.y(),
            width: Math.min(Math.max(node.width() * scaleX, 25), 150),
            height: Math.min(Math.max(node.height() * scaleY, 25), 150)
          }));
        },
        onDragEnd: function onDragEnd(e) {
          var x = Math.round(e.target.x() / gridSize) * gridSize;
          var y = Math.round(e.target.y() / gridSize) * gridSize;
          _this3.shapeRef.current.position({
            x: x,
            y: y
          });
          updateItem(_objectSpread$f(_objectSpread$f({}, item), {}, {
            x: x,
            y: y
          }));
        }
      }), item.showText && /*#__PURE__*/React.createElement(Text, {
        name: name,
        x: item.x,
        y: item.y + item.height,
        width: item.width,
        height: item.height,
        text: item.text || this.state.options.text
      })) :
      /*#__PURE__*/
      // Now the data is displayed as red when impossible to render as barcode. Maybe something else would work better...
      React.createElement(Text, {
        name: name,
        x: item.x,
        y: item.y,
        width: item.width,
        height: item.height,
        text: item.text,
        fill: 'red'
      }), readonly || !move ? null : /*#__PURE__*/React.createElement(AddTransformer, {
        ref: this.trRef,
        selectedShapeName: isSelected ? name : null
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var itm_type = nextProps.item.type === 'gs-128' ? 'gs1-128' : nextProps.item.type;
      var nextText = nextProps.useDummyData ? DUMMY_BARCODE_CODE[itm_type] : nextProps.item.text;
      if (prevState.options.bcid !== itm_type || prevState.options.text !== nextText) {
        return _objectSpread$f(_objectSpread$f({}, prevState), {}, {
          options: _objectSpread$f(_objectSpread$f({}, prevState.options), {}, {
            bcid: itm_type,
            text: nextText
          })
        });
      }
      return null;
    }
  }]);
}(React.Component);
Barcode.propTypes = {
  readonly: PropTypes.bool,
  item: PropTypes.object,
  selectedItemId: PropTypes.number,
  selectItem: PropTypes.func.isRequired,
  updateItem: PropTypes.func.isRequired,
  layout: PropTypes.object,
  standAlone: PropTypes.bool,
  useDummyData: PropTypes.bool,
  move: PropTypes.bool
};
Barcode.defaultProps = {
  readonly: false,
  useDummyData: true,
  selectItem: function selectItem() {},
  updateItem: function updateItem() {}
};

function ownKeys$e(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$e(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$e(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$e(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$d(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$d() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$d() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$d = function _isNativeReflectConstruct() { return !!t; })(); }
var DrawEllipse = /*#__PURE__*/function (_React$Component) {
  function DrawEllipse() {
    var _this;
    _classCallCheck(this, DrawEllipse);
    _this = _callSuper$d(this, DrawEllipse);
    _defineProperty(_this, "dragBound", function (pos) {
      var _dragBoundItem = dragBoundItem(pos, _this.props.layout, _this.props.item),
        x = _dragBoundItem.x,
        y = _dragBoundItem.y;
      return {
        x: x,
        y: y
      };
    });
    _this.shapeRef = /*#__PURE__*/React.createRef();
    _this.trRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  _inherits(DrawEllipse, _React$Component);
  return _createClass(DrawEllipse, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        item = _this$props.item,
        move = _this$props.move,
        selectedItemId = _this$props.selectedItemId,
        readonly = _this$props.readonly,
        selectItem = _this$props.selectItem,
        updateItem = _this$props.updateItem;
      var isSelected = item.id === selectedItemId;
      var name = 'ellipse' + item.id;
      return /*#__PURE__*/React.createElement(React.Fragment, null, isSelected && !readonly && /*#__PURE__*/React.createElement(Ellipse, {
        x: item.x - 2,
        y: item.y - 2,
        width: item.width + 4,
        height: item.height + 4,
        rotation: item.rotation,
        stroke: '#99EEFF88',
        strokeWidth: 2,
        shadowBlur: 10,
        shadowOffset: {
          x: 5,
          y: 5
        },
        shadowOpacity: 0.5
      }), /*#__PURE__*/React.createElement(Ellipse, {
        name: name,
        ref: this.shapeRef,
        x: item.x,
        y: item.y,
        radiusX: item.radiusX,
        radiusY: item.radiusY,
        width: item.width,
        height: item.height,
        rotation: item.rotation,
        stroke: 'black',
        strokeWidth: item.strokeWidth,
        draggable: move && selectedItemId === item.id,
        dragBoundFunc: this.dragBound,
        onClick: readonly ? null : function () {
          return selectItem(item.id);
        },
        shadowBlur: 2,
        onTransformEnd: function onTransformEnd(e) {
          // transformer is changing scale
          var node = _this2.shapeRef.current;
          var scaleX = node.scaleX();
          var scaleY = node.scaleY();

          // we will reset it back
          node.scaleX(1);
          node.scaleY(1);
          updateItem(_objectSpread$e(_objectSpread$e({}, item), {}, {
            x: node.x(),
            y: node.y(),
            width: node.width() * scaleX,
            height: node.height() * scaleY
          }));
        },
        onDragEnd: function onDragEnd(e) {
          // const x = Math.round(e.target.x() / 30) * 30;
          // const y = Math.round(e.target.y() / 30) * 30;
          // this.shapeRef.current.position({
          //   x,
          //   y,
          // });
          updateItem(_objectSpread$e(_objectSpread$e({}, item), {}, {
            x: e.target.x(),
            y: e.target.y(),
            radiusX: item.radiusX,
            radiusY: item.radiusY
          }));
        }
      }), readonly || !move ? null : /*#__PURE__*/React.createElement(AddTransformer, {
        ref: this.trRef,
        selectedShapeName: isSelected ? name : null
      }));
    }
  }]);
}(React.Component);
DrawEllipse.propTypes = {
  readonly: PropTypes.bool,
  item: PropTypes.object,
  selectedItemId: PropTypes.number,
  layout: PropTypes.object,
  selectItem: PropTypes.func.isRequired,
  updateItem: PropTypes.func.isRequired,
  move: PropTypes.bool
};
DrawEllipse.defaultProps = {
  readonly: false,
  selectItem: function selectItem() {},
  updateItem: function updateItem() {}
};

function ownKeys$d(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$d(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$d(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$d(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$c(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$c() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$c() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$c = function _isNativeReflectConstruct() { return !!t; })(); }
var DrawLine = /*#__PURE__*/function (_React$Component) {
  function DrawLine() {
    var _this;
    _classCallCheck(this, DrawLine);
    _this = _callSuper$c(this, DrawLine);
    _defineProperty(_this, "dragBound", function (pos, rotation) {
      var _dragBoundItem = dragBoundItem(pos, _this.props.layout, _this.props.item, rotation),
        x = _dragBoundItem.x,
        y = _dragBoundItem.y;
      return {
        x: x,
        y: y
      };
    });
    _this.shapeRef = /*#__PURE__*/React.createRef();
    _this.trRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  _inherits(DrawLine, _React$Component);
  return _createClass(DrawLine, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        item = _this$props.item,
        move = _this$props.move,
        selectedItemId = _this$props.selectedItemId,
        readonly = _this$props.readonly,
        selectItem = _this$props.selectItem,
        updateItem = _this$props.updateItem;
      var isSelected = item.id === this.props.selectedItemId;
      var name = 'line' + item.id;
      return /*#__PURE__*/React.createElement(React.Fragment, null, isSelected && !readonly && /*#__PURE__*/React.createElement(Rect, {
        x: item.x - 2,
        y: item.y - 2,
        width: item.width + 10,
        height: item.height + 10,
        stroke: '#99EEFF88',
        strokeWidth: 2,
        shadowBlur: 10,
        shadowOffset: {
          x: 5,
          y: 5
        },
        shadowOpacity: 0.5,
        rotation: item.rotation
      }), /*#__PURE__*/React.createElement(Line, {
        name: name,
        x: item.x,
        y: item.y,
        points: [0, 0, item.width, item.height] /*,item.x1,item.y1,item.x2,item.y2]*/,
        stroke: "black",
        strokeWidth: item.strokeWidth,
        draggable: move && selectedItemId === item.id,
        rotation: item.rotation,
        onClick: readonly ? null : function () {
          return selectItem(item.id);
        },
        dragBoundFunc: function dragBoundFunc(pos) {
          return _this2.dragBound(pos, Number(item.rotation));
        },
        onTransformEnd: function onTransformEnd(e) {
          // transformer is changing scale
          var node = _this2.shapeRef.current;
          var scaleX = node.scaleX();
          var scaleY = node.scaleY();

          // we will reset it back
          node.scaleX(1);
          node.scaleY(1);
          updateItem(_objectSpread$d(_objectSpread$d({}, item), {}, {
            x: node.x(),
            y: node.y(),
            width: node.width() * scaleX,
            height: node.height() * scaleY
          }));
        },
        onDragEnd: function onDragEnd(e) {
          var x = Math.round(e.target.x() / gridSize) * gridSize;
          var y = Math.round(e.target.y() / gridSize) * gridSize;
          _this2.shapeRef.current.position({
            x: x,
            y: y
          });
          updateItem(_objectSpread$d(_objectSpread$d({}, item), {}, {
            x: x,
            y: y
          }));
        },
        ref: this.shapeRef
      }), readonly || !move ? null : /*#__PURE__*/React.createElement(AddTransformer, {
        ref: this.trRef,
        selectedShapeName: isSelected ? name : null
      }));
    }
  }]);
}(React.Component);
DrawLine.propTypes = {
  readonly: PropTypes.bool,
  item: PropTypes.object,
  selectedItemId: PropTypes.number,
  selectItem: PropTypes.func.isRequired,
  updateItem: PropTypes.func.isRequired,
  layout: PropTypes.object,
  move: PropTypes.bool
};
DrawLine.defaultProps = {
  readonly: false,
  selectItem: function selectItem() {},
  updateItem: function updateItem() {}
};

function ownKeys$c(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$c(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$c(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$c(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$b(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$b() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$b() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$b = function _isNativeReflectConstruct() { return !!t; })(); }
var LabelVariable = /*#__PURE__*/function (_React$Component) {
  function LabelVariable() {
    var _this;
    _classCallCheck(this, LabelVariable);
    _this = _callSuper$b(this, LabelVariable);
    _defineProperty(_this, "dragBound", function (pos, rotation) {
      var _dragBoundItem = dragBoundItem(pos, _this.props.layout, _this.props.item, rotation),
        x = _dragBoundItem.x,
        y = _dragBoundItem.y;
      return {
        x: x,
        y: y
      };
    });
    _this.state = {
      isDragging: false,
      x: 80,
      y: 80
    };
    _this.shapeRef = /*#__PURE__*/React.createRef();
    _this.trRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  _inherits(LabelVariable, _React$Component);
  return _createClass(LabelVariable, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        item = _this$props.item,
        varInfo = _this$props.varInfo,
        isPreview = _this$props.isPreview,
        selectedItemId = _this$props.selectedItemId,
        selectItem = _this$props.selectItem,
        move = _this$props.move,
        readonly = _this$props.readonly,
        updateItem = _this$props.updateItem;
      var name = 'write' + item.id;
      var isSelected = item.id === selectedItemId;
      return /*#__PURE__*/React.createElement(React.Fragment, null, isSelected && !readonly && /*#__PURE__*/React.createElement(Rect, {
        x: item.x - 2,
        y: item.y - 2,
        width: item.width + 4,
        height: item.height + 4,
        stroke: '#99EEFF88',
        strokeWidth: 2,
        shadowBlur: 10,
        shadowOffset: {
          x: 5,
          y: 5
        },
        shadowOpacity: 0.5,
        rotation: item.rotation
      }), /*#__PURE__*/React.createElement(Text, {
        text: isPreview ? item.text : "[".concat(varInfo ? varInfo.label : '', "]"),
        ref: this.shapeRef,
        x: item.x,
        y: item.y,
        align: item.align,
        verticalAlign: item.verticalAlign,
        fill: 'black',
        name: name,
        fontSize: item.fontSize,
        width: item.width,
        height: item.height,
        fontStyle: item.fontStyle,
        rotation: item.rotation,
        textDecoration: item.textDecoration,
        draggable: move && selectedItemId === item.id,
        dragBoundFunc: function dragBoundFunc(pos) {
          return _this2.dragBound(pos, Number(item.rotation));
        },
        fontFamily: item.fontFamily
        //fill={this.state.isDragging ? 'green' : 'black'}
        ,
        onClick: this.props.readonly ? null : function () {
          return selectItem(item.id);
        },
        onDragStart: function onDragStart() {
          _this2.setState({
            isDragging: true
          });
        },
        onDragEnd: function onDragEnd(e) {
          var x = Math.round(e.target.x() / gridSize) * gridSize;
          var y = Math.round(e.target.y() / gridSize) * gridSize;
          if (_this2.shapeRef.current) {
            _this2.shapeRef.current.position({
              x: x,
              y: y
            });
          }
          updateItem(_objectSpread$c(_objectSpread$c({}, item), {}, {
            x: x,
            y: y
          }));
        },
        onTransformEnd: function onTransformEnd(e) {
          // transformer is changing scale
          var node = _this2.shapeRef.current;
          var scaleX = node.scaleX();
          var scaleY = node.scaleY();

          // we will reset it back
          node.scaleX(1);
          node.scaleY(1);
          updateItem(_objectSpread$c(_objectSpread$c({}, item), {}, {
            x: node.x(),
            y: node.y(),
            width: node.width() * scaleX,
            height: node.height() * scaleY
          }));
        }
      }), readonly || !move ? null : /*#__PURE__*/React.createElement(AddTransformer, {
        ref: this.trRef,
        selectedShapeName: isSelected ? name : null
      }));
    }
  }]);
}(React.Component);
LabelVariable.propTypes = {
  readonly: PropTypes.bool,
  item: PropTypes.object,
  varInfo: PropTypes.object,
  selectedItemId: PropTypes.number,
  selectItem: PropTypes.func.isRequired,
  updateItem: PropTypes.func.isRequired,
  layout: PropTypes.object,
  isPreview: PropTypes.bool,
  formatters: PropTypes.object,
  move: PropTypes.bool
};
LabelVariable.defaultProps = {
  readonly: false,
  selectItem: function selectItem() {},
  updateItem: function updateItem() {},
  isPreview: false
};

function ownKeys$b(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$b(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$b(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$b(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$a(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$a() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$a() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$a = function _isNativeReflectConstruct() { return !!t; })(); }
var ImageDisplay = /*#__PURE__*/function (_React$Component) {
  function ImageDisplay(props) {
    var _this;
    _classCallCheck(this, ImageDisplay);
    _this = _callSuper$a(this, ImageDisplay, [props]);
    _defineProperty(_this, "dragBound", function (pos, rotation) {
      var _dragBoundItem = dragBoundItem(pos, _this.props.layout, _this.props.item, rotation),
        x = _dragBoundItem.x,
        y = _dragBoundItem.y;
      return {
        x: x,
        y: y
      };
    });
    _this.state = {
      image: null
    };
    _this.shapeRef = /*#__PURE__*/React.createRef();
    _this.trRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  _inherits(ImageDisplay, _React$Component);
  return _createClass(ImageDisplay, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var image = new window.Image();
      image.src = this.props.item.image;
      image.onload = function () {
        // setState will redraw layer
        // because "image" property is changed
        _this2.setState({
          image: image
        });
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        item = _this$props.item,
        move = _this$props.move,
        selectedItemId = _this$props.selectedItemId,
        readonly = _this$props.readonly,
        selectItem = _this$props.selectItem,
        updateItem = _this$props.updateItem;
      var isSelected = item.id === selectedItemId;
      var name = 'image' + item.id;
      return /*#__PURE__*/React.createElement(React.Fragment, null, isSelected && !readonly && /*#__PURE__*/React.createElement(Rect, {
        x: item.x - 2,
        y: item.y - 2,
        width: item.width + 4,
        height: item.height + 4,
        stroke: '#99EEFF88',
        strokeWidth: 2,
        shadowBlur: 10,
        shadowOffset: {
          x: 5,
          y: 5
        },
        shadowOpacity: 0.5,
        rotation: item.rotation
      }), /*#__PURE__*/React.createElement(Image, {
        name: name,
        x: item.x,
        y: item.y,
        ref: this.shapeRef,
        image: this.state.image,
        width: item.width,
        height: item.height,
        rotation: item.rotation,
        draggable: move && selectedItemId === item.id,
        dragBoundFunc: function dragBoundFunc(pos) {
          return _this3.dragBound(pos, Number(item.rotation));
        },
        onClick: readonly ? null : function () {
          return selectItem(item.id);
        },
        onTransformEnd: function onTransformEnd(e) {
          // transformer is changing scale
          var node = _this3.shapeRef.current;
          if (node) {
            var scaleX = node.scaleX();
            var scaleY = node.scaleY();

            // we will reset it back
            node.scaleX(1);
            node.scaleY(1);
            updateItem(_objectSpread$b(_objectSpread$b({}, item), {}, {
              x: node.x(),
              y: node.y(),
              width: node.width() * scaleX,
              height: node.height() * scaleY
            }));
          }
        },
        onDragEnd: function onDragEnd(e) {
          var _this3$shapeRef$curre;
          var x = Math.round(e.target.x() / gridSize) * gridSize;
          var y = Math.round(e.target.y() / gridSize) * gridSize;
          (_this3$shapeRef$curre = _this3.shapeRef.current) === null || _this3$shapeRef$curre === void 0 || _this3$shapeRef$curre.position({
            x: x,
            y: y
          });
          updateItem(_objectSpread$b(_objectSpread$b({}, item), {}, {
            x: x,
            y: y
          }));
        }
      }), readonly || !move ? null : /*#__PURE__*/React.createElement(AddTransformer, {
        ref: this.trRef,
        selectedShapeName: isSelected ? name : null
      }));
    }
  }]);
}(React.Component);
ImageDisplay.propTypes = {
  readonly: PropTypes.bool,
  item: PropTypes.object,
  layout: PropTypes.object,
  selectedItemId: PropTypes.number,
  selectItem: PropTypes.func.isRequired,
  updateItem: PropTypes.func.isRequired,
  move: PropTypes.bool
};
ImageDisplay.defaultProps = {
  readonly: false,
  selectItem: function selectItem() {},
  updateItem: function updateItem() {}
};

function _callSuper$9(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$9() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$9() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$9 = function _isNativeReflectConstruct() { return !!t; })(); }
var Item = /*#__PURE__*/function (_React$Component) {
  function Item() {
    _classCallCheck(this, Item);
    return _callSuper$9(this, Item, arguments);
  }
  _inherits(Item, _React$Component);
  return _createClass(Item, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        item = _this$props.item,
        isPreview = _this$props.isPreview;
      var readonly = isPreview && !item.customText;
      if (item.itemType === ITEM_TEXT) {
        return /*#__PURE__*/React.createElement(Write, _extends({}, this.props, {
          readonly: readonly
        }));
      } else if (item.itemType === ITEM_VARIABLE) {
        return /*#__PURE__*/React.createElement(LabelVariable, this.props);
      } else if (item.itemType === ITEM_BARCODE) {
        return /*#__PURE__*/React.createElement(Barcode, this.props);
      } else if (item.itemType === ITEM_ELLIPSE) {
        return /*#__PURE__*/React.createElement(DrawEllipse, this.props);
      } else if (item.itemType === ITEM_LINE) {
        return /*#__PURE__*/React.createElement(DrawLine, this.props);
      } else if (item.itemType === ITEM_RECTANGLE) {
        return /*#__PURE__*/React.createElement(Rectangle, this.props);
      } else if (item.itemType === ITEM_IMAGE) {
        return /*#__PURE__*/React.createElement(ImageDisplay, this.props);
      } else {
        return null;
      }
    }
  }]);
}(React.Component);
Item.propTypes = {
  item: PropTypes.object,
  layout: PropTypes.object,
  selectItem: PropTypes.func,
  updateItem: PropTypes.func,
  selectedItemId: PropTypes.number,
  useDummyData: PropTypes.bool,
  isPreview: PropTypes.bool
};
Item.defaultProps = {
  useDummyData: true,
  readonly: false
};

/**
 * Compute GTIN check digit.
 * Supports GTIN-8, GTIN-12, GTIN-13 (= EAN-13), GTIN-14, GSIN, SSCC.
 * The last digit of the code is the check digit.
 *
 * @param {(string|number)} code Code without check digit
 * @returns {string} The check digit, or null if invalid code
 */
function computeGTINCheckDigit(code) {
  if (!/^\d{7,18}$/.test(code)) return null; //code must be digits only, 7-18 digits

  var digits = _toConsumableArray(String(code).padStart(18, '0'));
  var weights = Array(9).fill([1, 3]).flat();
  var reducer = function reducer(accumulator, weight, i) {
    return accumulator + weight * digits[i];
  };
  var sum = weights.reduce(reducer, 0);
  var remainder = sum % 10;
  return String(remainder ? 10 - remainder : 0);
}

// bwip-js/examples/drawing-svg.js
//
// This is an advanced demonstation of using the drawing interface.
//
// Converts the drawing primitives into the equivalent SVG.  Linear barcodes
// are rendered as a series of stroked paths.  2D barcodes are rendered as a
// series of filled paths.
//
// Rotation is handled during drawing.  The resulting SVG will contain the
// already-rotated barcode without an SVG transform.
//
// If the requested barcode image contains text, the glyph paths are
// extracted from the font file (via the builtin FontLib and stb_truetype.js)
// and added as filled SVG paths.
//
// This code can run in the browser and in nodejs.
function DrawingSVG(opts, FontLib) {
  // Unrolled x,y rotate/translate matrix
  var tx0 = 0,
    tx1 = 0,
    tx2 = 0,
    tx3 = 0;
  var ty0 = 0,
    ty1 = 0,
    ty2 = 0,
    ty3 = 0;
  var svg = '';
  var path;
  var lines = {};

  // Magic number to approximate an ellipse/circle using 4 cubic beziers.
  var ELLIPSE_MAGIC = 0.55228475 - 0.00045;

  // Global graphics state
  var gs_width, gs_height; // image size, in pixels
  var gs_dx, gs_dy; // x,y translate (padding)

  return {
    // Make no adjustments
    scale: function scale(sx, sy) {},
    // Measure text.  This and scale() are the only drawing primitives that
    // are called before init().
    //
    // `font` is the font name typically OCR-A or OCR-B.
    // `fwidth` and `fheight` are the requested font cell size.  They will
    // usually be the same, except when the scaling is not symetric.
    measure: function measure(str, font, fwidth, fheight) {
      fwidth = fwidth | 0;
      fheight = fheight | 0;
      var fontid = FontLib.lookup(font);
      var width = 0;
      var ascent = 0;
      var descent = 0;
      for (var i = 0; i < str.length; i++) {
        var ch = str.charCodeAt(i);
        var glyph = FontLib.getpaths(fontid, ch, fwidth, fheight);
        if (!glyph) {
          continue;
        }
        ascent = Math.max(ascent, glyph.ascent);
        descent = Math.max(descent, -glyph.descent);
        width += glyph.advance;
      }
      return {
        width: width,
        ascent: ascent,
        descent: descent
      };
    },
    // width and height represent the maximum bounding box the graphics will occupy.
    // The dimensions are for an unrotated rendering.  Adjust as necessary.
    init: function init(width, height) {
      // Add in the effects of padding.  These are always set before the
      // drawing constructor is called.
      var padl = opts.paddingleft;
      var padr = opts.paddingright;
      var padt = opts.paddingtop;
      var padb = opts.paddingbottom;
      var rot = opts.rotate || 'N';
      width += padl + padr;
      height += padt + padb;

      // Transform indexes are: x, y, w, h
      switch (rot) {
        // tx = w-y, ty = x
        case 'R':
          tx1 = -1;
          tx2 = 1;
          ty0 = 1;
          break;
        // tx = w-x, ty = h-y
        case 'I':
          tx0 = -1;
          tx2 = 1;
          ty1 = -1;
          ty3 = 1;
          break;
        // tx = y, ty = h-x
        case 'L':
          tx1 = 1;
          ty0 = -1;
          ty3 = 1;
          break;
        // tx = x, ty = y
        default:
          tx0 = ty1 = 1;
          break;
      }

      // Setup the graphics state
      var swap = rot == 'L' || rot == 'R';
      gs_width = swap ? height : width;
      gs_height = swap ? width : height;
      gs_dx = padl;
      gs_dy = padt;
      svg = '';
    },
    // Unconnected stroked lines are used to draw the bars in linear barcodes.
    // No line cap should be applied.  These lines are always orthogonal.
    line: function line(x0, y0, x1, y1, lw, rgb) {
      // Try to get non-blurry lines...
      x0 = x0 | 0;
      y0 = y0 | 0;
      x1 = x1 | 0;
      y1 = y1 | 0;
      lw = Math.round(lw);

      // Try to keep the lines "crisp" by using with the SVG line drawing spec to
      // our advantage.
      if (lw & 1) {
        if (x0 == x1) {
          x0 += 0.5;
          x1 += 0.5;
        }
        if (y0 == y1) {
          y0 += 0.5;
          y1 += 0.5;
        }
      }

      // Group together all lines of the same width and emit as single paths.
      // Dramatically reduces resulting text size.
      var key = '' + lw + '#' + rgb;
      if (!lines[key]) {
        lines[key] = '<path stroke="#' + rgb + '" stroke-width="' + lw + '" d="';
      }
      lines[key] += 'M' + transform(x0, y0) + 'L' + transform(x1, y1);
    },
    // Polygons are used to draw the connected regions in a 2d barcode.
    // These will always be unstroked, filled, non-intersecting,
    // orthogonal shapes.
    // You will see a series of polygon() calls, followed by a fill().
    polygon: function polygon(pts) {
      if (!path) {
        path = '<path d="';
      }
      path += 'M' + transform(pts[0][0], pts[0][1]);
      for (var i = 1, n = pts.length; i < n; i++) {
        var p = pts[i];
        path += 'L' + transform(p[0], p[1]);
      }
      path += 'Z';
    },
    // An unstroked, filled hexagon used by maxicode.  You can choose to fill
    // each individually, or wait for the final fill().
    //
    // The hexagon is drawn from the top, counter-clockwise.
    hexagon: function hexagon(pts, rgb) {
      this.polygon(pts); // A hexagon is just a polygon...
    },
    // An unstroked, filled ellipse.  Used by dotcode and maxicode at present.
    // maxicode issues pairs of ellipse calls (one cw, one ccw) followed by a fill()
    // to create the bullseye rings.  dotcode issues all of its ellipses then a
    // fill().
    ellipse: function ellipse(x, y, rx, ry, ccw) {
      if (!path) {
        path = '<path d="';
      }
      var dx = rx * ELLIPSE_MAGIC;
      var dy = ry * ELLIPSE_MAGIC;

      // Since we fill with even-odd, don't worry about cw/ccw
      path += 'M' + transform(x - rx, y) + 'C' + transform(x - rx, y - dy) + ' ' + transform(x - dx, y - ry) + ' ' + transform(x, y - ry) + 'C' + transform(x + dx, y - ry) + ' ' + transform(x + rx, y - dy) + ' ' + transform(x + rx, y) + 'C' + transform(x + rx, y + dy) + ' ' + transform(x + dx, y + ry) + ' ' + transform(x, y + ry) + 'C' + transform(x - dx, y + ry) + ' ' + transform(x - rx, y + dy) + ' ' + transform(x - rx, y) + 'Z';
    },
    // PostScript's default fill rule is even-odd.
    fill: function fill(rgb) {
      if (path) {
        svg += path + '" fill="#' + rgb + '" fill-rule="evenodd" />\n';
        path = null;
      }
    },
    // Draw text with optional inter-character spacing.  `y` is the baseline.
    // font is an object with properties { name, width, height, dx }
    // width and height are the font cell size.
    // dx is extra space requested between characters (usually zero).
    text: function text(x, y, str, rgb, font) {
      var fontid = FontLib.lookup(font.name);
      var fwidth = font.width | 0;
      var fheight = font.height | 0;
      var dx = font.dx | 0;
      var path = '';
      for (var k = 0; k < str.length; k++) {
        var ch = str.charCodeAt(k);
        var glyph = FontLib.getpaths(fontid, ch, fwidth, fheight);
        if (!glyph) {
          continue;
        }
        if (glyph.length) {
          // A glyph is composed of sequence of curve and line segments.
          // M is move-to
          // L is line-to
          // Q is quadratic bezier curve-to
          // C is cubic bezier curve-to
          for (var i = 0, l = glyph.length; i < l; i++) {
            var seg = glyph[i];
            if (seg.type == 'M' || seg.type == 'L') {
              path += seg.type + transform(seg.x + x, y - seg.y);
            } else if (seg.type == 'Q') {
              path += seg.type + transform(seg.cx + x, y - seg.cy) + ' ' + transform(seg.x + x, y - seg.y);
            } else if (seg.type == 'C') {
              path += seg.type + transform(seg.cx1 + x, y - seg.cy1) + ' ' + transform(seg.cx2 + x, y - seg.cy2) + ' ' + transform(seg.x + x, y - seg.y);
            }
          }
          // Close the shape
          path += 'Z';
        }
        x += glyph.advance + dx;
      }
      if (path) {
        svg += '<path d="' + path + '" fill="#' + rgb + '" />\n';
      }
    },
    // Called after all drawing is complete.  The return value from this method
    // is the return value from `bwipjs.render()`.
    end: function end() {
      var linesvg = '';
      for (var key in lines) {
        linesvg += lines[key] + '" />\n';
      }
      var bg = opts.backgroundcolor;
      return '<svg version="1.1" width="' + gs_width + '" height="' + gs_height + '" xmlns="http://www.w3.org/2000/svg">\n' + (/^[0-9A-Fa-f]{6}$/.test('' + bg) ? '<rect width="100%" height="100%" fill="#' + bg + '" />\n' : '') + linesvg + svg + '</svg>\n';
    }
  };

  // translate/rotate and return as an SVG coordinate pair
  function transform(x, y) {
    x += gs_dx;
    y += gs_dy;
    var tx = tx0 * x + tx1 * y + tx2 * (gs_width - 1) + tx3 * (gs_height - 1);
    var ty = ty0 * x + ty1 * y + ty2 * (gs_width - 1) + ty3 * (gs_height - 1);
    return '' + ((tx | 0) == tx ? tx : tx.toFixed(2)) + ' ' + ((ty | 0) == ty ? ty : ty.toFixed(2));
  }
}

function ownKeys$a(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$a(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$a(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$a(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function assignVariables(layout, values) {
  return _objectSpread$a(_objectSpread$a({}, layout), {}, {
    items: Object.fromEntries(Object.entries(layout.items).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        item = _ref2[1];
      var data = assignItem(item, values);
      if (item.itemType === 'barcode') {
        try {
          var opts = {
            bcid: item.type,
            // Barcode type
            text: data.text,
            // Text to encode
            scale: 3,
            // 3x scaling factor
            height: 20,
            // Bar height, in millimeters
            includetext: false,
            // Show human-readable text
            textxalign: 'center',
            // Always good to set this
            dontlint: true
          };
          var svg = bwipjs.render(opts, DrawingSVG(opts, bwipjs.FontLib));
          data.svg = svg;
        } catch (e) {
          console.log('SVG error:', e);
        }
      }
      return [key, data];
    }))
  });
}
function assignItem(item, values) {
  switch (item.itemType) {
    case ITEM_VARIABLE:
      return _objectSpread$a(_objectSpread$a({}, item), {}, {
        text: values[item.varCode] || ''
      });
    case ITEM_BARCODE:
      return assignBarcodeItem(item, values);
    default:
      return item;
  }
}
function assignBarcodeItem(item, values) {
  var varCode = item.varCode,
    prefix = item.prefix,
    type = item.type;
  prefix = prefix || '';
  var value = values[varCode] || '';
  var text = ''; // return empty text if error

  // padding and check digit calculation for fixed length types
  var fixedLength = BARCODELENGTH[type];
  if (fixedLength && value) {
    if (!prefix && value.length === fixedLength) {
      // Value should already have correct check digit, let's check
      var checkDigit = computeGTINCheckDigit(value.substring(0, fixedLength - 1));
      if (value.charAt(fixedLength - 1) === checkDigit)
        // correct check digit
        text = value;
    } else {
      // Add prefix, padding and check digit
      var padLength = fixedLength - prefix.length - 1;
      if (padLength >= value.length) {
        // value is short enough
        value = prefix + value.padStart(padLength, '0');
        var _checkDigit = computeGTINCheckDigit(value);
        if (_checkDigit != null) {
          text = value + _checkDigit;
        }
      }
    }
  } else {
    text = prefix + value;
  }
  return _objectSpread$a(_objectSpread$a({}, item), {}, {
    text: text
  });
}

function ownKeys$9(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$9(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$9(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$9(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$8(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$8() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$8() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$8 = function _isNativeReflectConstruct() { return !!t; })(); }
var Preview = /*#__PURE__*/function (_React$Component) {
  function Preview(props) {
    var _this;
    _classCallCheck(this, Preview);
    _this = _callSuper$8(this, Preview, [props]);
    _defineProperty(_this, "printRequested", function (printername) {
      var stage = _this.stageref.getStage();
      var layout = assignVariables(_this.props.standAlone ? _this.state.layout : _this.props.layout, _this.props.orderItem);
      PrintImage(stage.toDataURL({
        pixelRatio: 4 // or other value you need
      }), JSON.stringify(layout), printername, _this.props.copies);
    });
    _defineProperty(_this, "updateItem", function (item) {
      // State layout and update is needed because the custom text editing needs to be send to Qt Side!
      _this.setState(function (state) {
        return {
          layout: _objectSpread$9(_objectSpread$9({}, state.layout), {}, {
            items: _objectSpread$9(_objectSpread$9({}, state.layout.items), {}, _defineProperty({}, item.id, _objectSpread$9({}, item)))
          })
        };
      });
    });
    _this.stageref = /*#__PURE__*/React.createRef();
    _this.state = {
      layout: null,
      prevLayout: null
    };
    return _this;
  }
  _inherits(Preview, _React$Component);
  return _createClass(Preview, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        selectItem = _this$props.selectItem,
        updateItem = _this$props.updateItem,
        selectedItemId = _this$props.selectedItemId,
        pWidth = _this$props.pWidth,
        pHeight = _this$props.pHeight,
        standAlone = _this$props.standAlone,
        useDummyData = _this$props.useDummyData,
        orderItem = _this$props.orderItem,
        zIndex = _this$props.zIndex,
        formatters = _this$props.formatters,
        classNames = _this$props.classNames;
      var layout = assignVariables(standAlone ? this.state.layout : this.props.layout, orderItem);
      var itemsArray = layout.itemids.map(function (id) {
        return layout.items[id];
      });
      var asp_rat = Math.min(pHeight / layout.height.pixel, pWidth / layout.width.pixel);
      var previewWidth = asp_rat * pWidth > pWidth ? layout.width.pixel : layout.width.pixel * asp_rat;
      var previewHeight = asp_rat * pHeight > pHeight ? layout.height.pixel : asp_rat * layout.height.pixel;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames,
        style: {
          backgroundColor: 'white',
          width: previewWidth,
          height: previewHeight,
          paddingTop: layout.marginTop * asp_rat,
          paddingBottom: layout.marginBottom * asp_rat,
          paddingLeft: layout.marginLeft * asp_rat,
          paddingRight: layout.marginRight * asp_rat
        },
        id: 'ep_editor_container'
      }, /*#__PURE__*/React.createElement(Stage, {
        width: previewWidth + 2 - layout.marginLeft * asp_rat - layout.marginRight * asp_rat,
        height: previewHeight + 2 - layout.marginTop * asp_rat - layout.marginBottom * asp_rat,
        ref: function ref(node) {
          _this2.stageref = node;
        },
        id: "stage"
        //changing scaling of preview in relation to the height and width of editor
        ,
        scaleX: asp_rat > 1 ? 1 : asp_rat,
        scaleY: asp_rat > 1 ? 1 : asp_rat
      }, /*#__PURE__*/React.createElement(Layer, null, itemsArray.map(function (item) {
        return /*#__PURE__*/React.createElement(Item, {
          isPreview: true,
          standAlone: standAlone,
          useDummyData: useDummyData,
          key: item.id,
          item: item,
          layout: layout,
          selectItem: selectItem,
          updateItem: standAlone ? _this2.updateItem : updateItem,
          selectedItemId: selectedItemId,
          zIndex: zIndex,
          formatters: formatters
        });
      }))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.standAlone) {
        // State layout and update is needed because the custom text editing needs to be send to Qt Side!
        if (!_.isEqual(props.layout, state.prevLayout)) {
          return {
            layout: props.layout,
            prevLayout: _.cloneDeep(props.layout)
          };
        }
      }
      return null;
    }
  }]);
}(React.Component); //TODO: I would recommend handling the variable filling in preview for the label data. That way the task needs to be done only once.
Preview.propTypes = {
  readonly: PropTypes.bool,
  layout: PropTypes.object.isRequired,
  selectItem: PropTypes.func,
  updateItem: PropTypes.func,
  selectedItemId: PropTypes.number,
  pWidth: PropTypes.number,
  pHeight: PropTypes.number,
  standAlone: PropTypes.bool,
  orderItem: PropTypes.object,
  // Object containing data for variables to be shown on preview,
  zIndex: PropTypes.string,
  formatters: PropTypes.object,
  // Functions to call to get the data in required format
  copies: PropTypes.number,
  // Parameters to pass on Qt printer
  useDummyData: PropTypes.bool,
  classNames: PropTypes.string
};
Preview.defaultProps = {
  readonly: false,
  pWidth: 350,
  pHeight: 350,
  standAlone: false,
  useDummyData: true,
  classNames: '',
  orderItem: {},
  zIndex: '0',
  copies: 1,
  selectItem: function selectItem() {},
  updateItem: function updateItem() {}
};
// eslint-disable-next-line react/display-name
var FinalPreview = /*#__PURE__*/forwardRef(function finalPreview(props, ref) {
  return /*#__PURE__*/React.createElement(Preview, _extends({}, props, {
    ref: ref
  }));
});

function _callSuper$7(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$7() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$7() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$7 = function _isNativeReflectConstruct() { return !!t; })(); }
var NewModal = /*#__PURE__*/function (_React$Component) {
  function NewModal(props) {
    var _this;
    _classCallCheck(this, NewModal);
    _this = _callSuper$7(this, NewModal, [props]);
    _defineProperty(_this, "load_layouts", function () {
      if (_this.props.newModalOpen && _this.state.layouts.length === 0) {
        // Start loading layout templates only when no layouts are available
        _this.props.axios.get('/templates/ep4').then(function (rs) {
          if (rs.status === 200) {
            _this.setState({
              layouts: rs.data
            });
          }
        })["catch"](function (reason) {
          return console.log(reason);
        });
      }
    });
    _this.state = {
      layouts: []
    };
    return _this;
  }
  _inherits(NewModal, _React$Component);
  return _createClass(NewModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        t = _this$props.t,
        newModalOpen = _this$props.newModalOpen,
        orderItem = _this$props.orderItem,
        formatters = _this$props.formatters,
        resetLayout = _this$props.resetLayout,
        load = _this$props.load,
        toggleNewModal = _this$props.toggleNewModal;
      this.load_layouts();
      var examples = this.state.layouts.map(function (x, idx) {
        return /*#__PURE__*/React.createElement(Row, {
          key: idx,
          className: "modalRow cursor-pointer",
          onClick: function onClick() {
            load(x);
            toggleNewModal(false);
          }
        }, /*#__PURE__*/React.createElement(Col, {
          className: "p-0"
        }, /*#__PURE__*/React.createElement(FinalPreview, {
          pWidth: 450,
          pHeight: 100,
          layout: x,
          orderItem: orderItem,
          formatters: formatters,
          classNames: "new-label-container"
        })));
      });
      return /*#__PURE__*/React.createElement(Modal, {
        isOpen: newModalOpen
      }, /*#__PURE__*/React.createElement(ModalHeader, {
        toggle: function toggle() {
          return toggleNewModal(false);
        }
      }, t('lbl.newLabel', 'New label')), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement("div", {
        className: "scroll"
      }, /*#__PURE__*/React.createElement(Row, {
        className: "modalRow cursor-pointer",
        onClick: function onClick() {
          resetLayout();
          toggleNewModal(false);
        }
      }, /*#__PURE__*/React.createElement(Col, {
        className: "p-0"
      }, /*#__PURE__*/React.createElement("div", {
        className: 'emptyLabel new-label-container'
      }, t('lbl.empty', '<Empty>')))), examples)), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          toggleNewModal(false);
        }
      }, t('fn.cancel', 'Cancel'))));
    }
  }]);
}(React.Component);
NewModal.propTypes = {
  t: PropTypes.func.isRequired,
  toggleNewModal: PropTypes.func.isRequired,
  resetLayout: PropTypes.func.isRequired,
  load: PropTypes.func.isRequired,
  newModalOpen: PropTypes.bool,
  orderItem: PropTypes.object,
  formatters: PropTypes.object,
  axios: PropTypes.any
};
var mapStateToProps$3 = function mapStateToProps(state) {
  return {
    newModalOpen: state.editor.newModalOpen
  };
};
var mapDispatchToProps$3 = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    resetLayout: actions$1.resetLayout,
    toggleNewModal: actions.toggleNewModal,
    load: actions$1.load
  }, dispatch);
};
var NewModal$1 = withTranslation('translations')(connect(mapStateToProps$3, mapDispatchToProps$3)(NewModal));

var _excluded$4 = ["className", "children", "style"];
var Navbar = function Navbar(props) {
  /**
   * flex: 0 0 16.666667%;
   * max-width: 16.666667%;
   */

  var className = props.className,
    children = props.children,
    style = props.style,
    rest = _objectWithoutProperties(props, _excluded$4);
  var classes = ['ep-navbar', className];
  return /*#__PURE__*/React.createElement("nav", _extends({
    className: classes.join(' '),
    style: style
  }, rest), children);
};
Navbar.propTypes = {
  children: PropTypes.any,
  style: PropTypes.object,
  className: PropTypes.string
};
Navbar.defaultProps = {
  style: {}
};

var _excluded$3 = ["className", "children", "style"];
var NavItem = function NavItem(props) {
  /**
   * flex: 0 0 16.666667%;
   * max-width: 16.666667%;
   */

  var className = props.className,
    children = props.children,
    style = props.style,
    rest = _objectWithoutProperties(props, _excluded$3);
  return /*#__PURE__*/React.createElement("li", _extends({
    className: className,
    style: style
  }, rest), children);
};
NavItem.propTypes = {
  children: PropTypes.any,
  style: PropTypes.object,
  className: PropTypes.string
};
NavItem.defaultProps = {
  style: {}
};

function ownKeys$8(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$8(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$8(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$8(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$6(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$6() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$6() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$6 = function _isNativeReflectConstruct() { return !!t; })(); }
var NavBar = /*#__PURE__*/function (_Component) {
  function NavBar(props) {
    var _this;
    _classCallCheck(this, NavBar);
    _this = _callSuper$6(this, NavBar, [props]);
    _defineProperty(_this, "handleFileNameChange", function (e) {
      _this.setState(_objectSpread$8(_objectSpread$8({}, _this.state), {}, {
        fileName: e.target.value
      }));
    });
    _defineProperty(_this, "toggleSaveModal", function () {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var layout = _this.props.layout;
      _this.setState(function (prevState) {
        return _objectSpread$8(_objectSpread$8({}, prevState), {}, {
          showSaveModal: !prevState.showSaveModal,
          showConfirmModal: false,
          saveType: type,
          fileName: layout.labelname || ''
        });
      });
    });
    _defineProperty(_this, "handleImport", function (event) {
      var t = _this.props.t;
      var file = event.target.files[0];
      if (!file) {
        return;
      }
      if (file.name.endsWith('.ept')) {
        var formData = new FormData();
        _this.setState({
          converting: true
        });
        formData.append('layout', file);
        _this.props.axios.post('/convert/ep3_to_ep4', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function (rs) {
          if (rs.status === 200) {
            _this.props.load(rs.data);
            _this.inputFile.current.value = null;
          } else {
            alert(t('error.unable_to_convert_template', 'Unable to convert the template'));
            _this.inputFile.current.value = null;
          }
          _this.setState({
            converting: false
          });
        })["catch"](function () {
          _this.setState({
            converting: false
          });
        });
      } else {
        var reader = new FileReader();
        reader.onload = function (e) {
          _this.props.load(JSON.parse(e.target.result));
          _this.inputFile.current.value = null;
        };
        reader.readAsText(file);
      }
    });
    _this.state = {
      showModal: false,
      fileName: '',
      saveType: '',
      converting: false
    };
    _this.saveToDB = _this.toggleSaveModal.bind(_this, 'DB');
    _this.saveToPC = _this.toggleSaveModal.bind(_this, 'PC');
    _this.inputFile = /*#__PURE__*/React.createRef();
    return _this;
  }
  _inherits(NavBar, _Component);
  return _createClass(NavBar, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (!_.isEqual(this.state, nextState)) {
        return true;
      }
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        layout = _this$props.layout,
        handleSaveDB = _this$props.handleSaveDB,
        t = _this$props.t,
        orderItem = _this$props.orderItem,
        formatters = _this$props.formatters,
        axios = _this$props.axios;
      var _this$state = this.state,
        saveType = _this$state.saveType,
        fileName = _this$state.fileName,
        showSaveModal = _this$state.showSaveModal;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SaveModal$1, {
        layout: layout,
        saveType: saveType,
        handleFileNameChange: this.handleFileNameChange,
        handleSaveDB: handleSaveDB,
        fileName: fileName,
        showSaveModal: showSaveModal,
        toggleSaveModal: this.toggleSaveModal
      }), /*#__PURE__*/React.createElement(NewModal$1, {
        orderItem: orderItem,
        formatters: formatters,
        axios: axios
      }), /*#__PURE__*/React.createElement(Row, {
        className: "m-0",
        style: {
          height: '120px',
          overflow: 'hidden'
        }
      }, /*#__PURE__*/React.createElement(Navbar, {
        className: "nav__container"
      }, /*#__PURE__*/React.createElement(Col, {
        className: "nav__splitter",
        xs: 4
      }, /*#__PURE__*/React.createElement(NavItem, {
        className: "nav__btns"
      }, /*#__PURE__*/React.createElement(IconButton, {
        inNavbar: true,
        onClick: this.props.handleExportClick,
        icon: "print",
        text: t('fn.print', 'Print')
      }), /*#__PURE__*/React.createElement(IconButton, {
        onClick: this.saveToDB,
        inNavbar: true,
        icon: "save",
        text: t('fn.save', 'Save')
      }), /*#__PURE__*/React.createElement(IconButton, {
        inNavbar: true,
        icon: "download",
        text: t('fn.download', 'Download'),
        onClick: this.saveToPC
      }), /*#__PURE__*/React.createElement("input", {
        type: "file",
        accept: '.json;*.ept',
        id: 'upload_input',
        onChange: this.handleImport,
        style: {
          display: 'none'
        },
        ref: this.inputFile
      }), /*#__PURE__*/React.createElement(IconButton, {
        inNavbar: true,
        icon: this.state.converting ? 'spinner' : 'file-import',
        text: this.state.converting ? t('lbl.converting', 'Converting...') : t('fn.file_import', 'Import'),
        spin: this.state.converting,
        onClick: function onClick() {
          return _this2.inputFile.current.click();
        }
      }))), /*#__PURE__*/React.createElement(Col, {
        xs: 8
      }, /*#__PURE__*/React.createElement(NavItem, {
        className: "nav__pageSettings"
      }, /*#__PURE__*/React.createElement(PageSettings$1, null))))));
    }
  }]);
}(Component);
NavBar.propTypes = {
  t: PropTypes.func.isRequired,
  layout: PropTypes.object,
  navbarForwardedRef: PropTypes.object,
  items: PropTypes.array,
  resetLayout: PropTypes.func,
  handleSaveDB: PropTypes.func,
  showPreview: PropTypes.bool,
  openPreview: PropTypes.func,
  load: PropTypes.func,
  axios: PropTypes.any,
  handleExportClick: PropTypes.func,
  orderItem: PropTypes.object,
  formatters: PropTypes.object
};
var mapStateToProps$2 = function mapStateToProps(state) {
  return {
    layout: state.layout,
    items: selectors$1.itemsAsArray(state)
  };
};
var mapDispatchToProps$2 = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    resetLayout: actions$1.resetLayout,
    load: actions$1.load
  }, dispatch);
};
var ConnectedNavbar = withTranslation('translations')(connect(mapStateToProps$2, mapDispatchToProps$2)(NavBar));
var FinalNavbar = /*#__PURE__*/forwardRef(function finalNavbar(props, ref) {
  return /*#__PURE__*/React.createElement(ConnectedNavbar, _extends({}, props, {
    navbarForwardedRef: ref
  }));
});

var css_248z$6 = ".toolbar__container {\n  background-color: #2d3e50;\n  font-size: 1.25rem;\n  color: white;\n  height: 100%;\n  padding:  0;\n}\n\n.toolbar__items {\n  width: 90%;\n  margin: 0 auto;\n  height: 100%;\n}\n\n.toolbar__item {\n  margin: 0;\n}\n\n.toolbar__createItemTitle {\n  padding: 0 0.5rem;\n  margin: 0 0.5rem;\n  font-weight: 600;\n}\n";
styleInject(css_248z$6);

var _excluded$2 = ["className", "children", "style"];
var Nav = function Nav(props) {
  /**
   * flex: 0 0 16.666667%;
   * max-width: 16.666667%;
   */

  var className = props.className,
    children = props.children,
    style = props.style,
    rest = _objectWithoutProperties(props, _excluded$2);
  var classes = ['ep-nav', className];
  return /*#__PURE__*/React.createElement("ul", _extends({
    className: classes.join(' '),
    style: style
  }, rest), children);
};
Nav.propTypes = {
  children: PropTypes.any,
  style: PropTypes.object,
  className: PropTypes.string
};
Nav.defaultProps = {
  style: {}
};

function ownKeys$7(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$7(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$7(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$7(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$5(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$5() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$5() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$5 = function _isNativeReflectConstruct() { return !!t; })(); }

//Default props for items
var defaultItems = {
  text: {
    itemType: ITEM_TEXT,
    text: 'Text',
    width: 50,
    height: 20,
    fontSize: 12,
    fontFamily: 'Noto Sans',
    customText: false,
    prompt: '',
    rotation: 0
  },
  variable: {
    itemType: ITEM_VARIABLE,
    varCode: '',
    width: 100,
    height: 20,
    x: 70,
    y: 10,
    fontSize: 12,
    rotation: 0,
    fontFamily: 'Noto Sans'
  },
  rect: {
    itemType: ITEM_RECTANGLE,
    width: 30,
    height: 30,
    x: 70,
    y: 60,
    rotation: 0
  },
  barcode: {
    itemType: ITEM_BARCODE,
    varCode: '',
    type: BARCODE_EAN13,
    width: 120,
    height: 50,
    image: '',
    rotation: 0
  },
  ellipse: {
    itemType: ITEM_ELLIPSE,
    width: 20,
    height: 15,
    radiusX: 30,
    radiusY: 30,
    x: 45,
    y: 40,
    rotation: 0
  },
  line: {
    itemType: ITEM_LINE,
    width: 100,
    height: 0,
    x: 30,
    y: 30,
    x0: 10,
    y0: 40,
    x1: 50,
    y1: 40,
    x2: 100,
    y2: 40,
    strokeWidth: 4,
    rotation: 0
  },
  QRcode: {
    itemType: ITEM_BARCODE,
    varCode: '',
    type: BARCODE_QRCODE,
    width: 50,
    height: 50,
    rotation: 0
  },
  image: {
    itemType: ITEM_IMAGE,
    image: '',
    width: 70,
    height: 70,
    x: 50,
    y: 50,
    rotation: 0
  }
};
var Toolbar = /*#__PURE__*/function (_Component) {
  function Toolbar() {
    var _this;
    _classCallCheck(this, Toolbar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$5(this, Toolbar, [].concat(args));
    _defineProperty(_this, "moveItems", function () {
      _this.props.updateMoveItem(!_this.props.move);
    });
    _defineProperty(_this, "clearAllItems", function () {
      _this.props.resetLayout();
      _this.props.toggleNewModal(true);
    });
    _defineProperty(_this, "displayText", function () {
      _this.addItem(defaultItems.text);
    });
    _defineProperty(_this, "displayRect", function () {
      _this.addItem(defaultItems.rect);
    });
    _defineProperty(_this, "displayBarcode", function () {
      _this.addItem(defaultItems.barcode);
    });
    _defineProperty(_this, "displayEllipse", function () {
      _this.addItem(defaultItems.ellipse);
    });
    _defineProperty(_this, "displayLine", function () {
      _this.addItem(defaultItems.line);
    });
    _defineProperty(_this, "displayVariable", function () {
      _this.addItem(defaultItems.variable);
    });
    _defineProperty(_this, "displayQRCode", function () {
      _this.addItem(defaultItems.QRcode);
    });
    _defineProperty(_this, "displayImage", function (files) {
      _this.addItem(_objectSpread$7(_objectSpread$7({}, defaultItems.image), {}, {
        image: files.base64
      }));
    });
    _defineProperty(_this, "drag", function (ev) {
      ev.dataTransfer.setData('text', String(ev.target.id).replace('item_', ''));
    });
    return _this;
  }
  _inherits(Toolbar, _Component);
  return _createClass(Toolbar, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.props.move !== nextProps.move) {
        return true;
      }
      return false;
    }
  }, {
    key: "addItem",
    value: function addItem(item) {
      var n = this.props.items.length;
      var newItem = _objectSpread$7(_objectSpread$7({}, item), {}, {
        x: 30 + 10 * n % 50,
        y: 30 + 10 * n % 50,
        id: this.props.items.length
      });
      this.props.createItem(newItem);
      this.props.selectItem(newItem.id);
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      return /*#__PURE__*/React.createElement(Navbar, {
        className: "toolbar__container"
      }, /*#__PURE__*/React.createElement(Nav, {
        className: "toolbar__items"
      }, /*#__PURE__*/React.createElement("p", {
        className: "toolbar__createItemTitle margin-0"
      }, t('fn.newItem', 'New Item')), /*#__PURE__*/React.createElement(NavItem, {
        className: "toolbar__item"
      }, /*#__PURE__*/React.createElement(IconButton, {
        icon: "t",
        text: t('lbl.text', 'Text'),
        iconSize: "1x",
        color: "primary",
        onClick: this.displayText,
        draggable: true,
        id: 'item_text',
        onDragStart: this.drag
      })), /*#__PURE__*/React.createElement(NavItem, {
        className: "toolbar__item"
      }, /*#__PURE__*/React.createElement(IconButton, {
        icon: "code",
        text: t('lbl.variable', 'Variable'),
        iconSize: "1x",
        color: "primary",
        onClick: this.displayVariable,
        draggable: true,
        id: 'item_variable',
        onDragStart: this.drag
      })), /*#__PURE__*/React.createElement(NavItem, {
        className: "toolbar__item"
      }, /*#__PURE__*/React.createElement(ReactFileReader, {
        fileTypes: ['.png', '.jpg', '.jpeg', '.gif'],
        base64: true,
        handleFiles: this.displayImage
      }, /*#__PURE__*/React.createElement(IconButton, {
        icon: "image",
        text: t('lbl.picture', 'Picture'),
        iconSize: "1x",
        color: "primary",
        onClick: undefined,
        draggable: false,
        id: 'image',
        onDragStart: undefined
      }))), /*#__PURE__*/React.createElement(NavItem, {
        className: "toolbar__item"
      }, /*#__PURE__*/React.createElement(IconButton, {
        icon: "barcode",
        text: t('lbl.barcode', 'Barcode'),
        iconSize: "1x",
        color: "primary",
        onClick: this.displayBarcode,
        draggable: true,
        id: 'item_barcode',
        onDragStart: this.drag
      })), /*#__PURE__*/React.createElement(NavItem, {
        className: "toolbar__item"
      }, /*#__PURE__*/React.createElement(IconButton, {
        icon: "qrcode",
        text: t('lbl.qrCode', 'QR Code'),
        iconSize: "1x",
        color: "primary",
        onClick: this.displayQRCode,
        draggable: true,
        id: 'item_QRcode',
        onDragStart: this.drag
      })), /*#__PURE__*/React.createElement(NavItem, {
        className: "toolbar__item"
      }, /*#__PURE__*/React.createElement(IconButton, {
        icon: "minus",
        text: t('lbl.line', 'Line'),
        iconSize: "1x",
        color: "primary",
        onClick: this.displayLine,
        draggable: true,
        id: 'item_line',
        onDragStart: this.drag
      })), /*#__PURE__*/React.createElement(NavItem, {
        className: "toolbar__item"
      }, /*#__PURE__*/React.createElement(IconButton, {
        icon: "fa-regular fa-square",
        text: t('opt.harmonies.3', 'Rectangle'),
        iconSize: "1x",
        color: "primary",
        onClick: this.displayRect,
        draggable: true,
        id: 'item_rect',
        onDragStart: this.drag
      })), /*#__PURE__*/React.createElement(NavItem, {
        className: "toolbar__item"
      }, /*#__PURE__*/React.createElement(IconButton, {
        icon: "fa-regular fa-circle",
        text: t('lbl.ellipse', 'Ellipse'),
        iconSize: "1x",
        color: "primary",
        onClick: this.displayEllipse,
        draggable: true,
        id: 'item_ellipse',
        onDragStart: this.drag
      })), /*#__PURE__*/React.createElement(NavItem, {
        className: "toolbar__item"
      }, /*#__PURE__*/React.createElement(IconButton, {
        icon: "xmark",
        text: t('fn.clearAll', 'Clear All'),
        iconSize: "1x",
        color: "danger",
        onClick: this.clearAllItems,
        draggable: false,
        onDragStart: undefined
      }))));
    }
  }]);
}(Component);
Toolbar.propTypes = {
  t: PropTypes.func.isRequired,
  layout: PropTypes.object,
  items: PropTypes.array,
  createItem: PropTypes.func,
  selectItem: PropTypes.func,
  resetLayout: PropTypes.func,
  updateMoveItem: PropTypes.func,
  toggleNewModal: PropTypes.func,
  showAlignment: PropTypes.bool,
  showEdit: PropTypes.bool,
  resetUI: PropTypes.func,
  move: PropTypes.bool
};
function mapStateToProps$1(state) {
  return {
    items: selectors$1.itemsAsArray(state),
    layout: state.layout,
    selectedItemId: selectors.selectedItemId(state),
    move: selectors.move(state)
  };
}
function mapDispatchToProps$1(dispatch) {
  return bindActionCreators({
    createItem: actions$1.createItem,
    updateItem: actions$1.updateItem,
    deleteItem: actions$1.deleteItem,
    moveItem: actions$1.moveItem,
    updateMoveItem: actions.updateMoveItem,
    toggleNewModal: actions.toggleNewModal,
    resetLayout: actions$1.resetLayout,
    selectItem: actions.selectItem
  }, dispatch);
}
var Toolbar$1 = withTranslation('translations')(connect(mapStateToProps$1, mapDispatchToProps$1)(Toolbar));

var css_248z$5 = ".layout__container {\n  background-color: #a9a9a9;\n  margin: 0;\n  height: 100%;\n}\n\n.labelEditor__container {\n  display: flex;\n  align-items: center;\n  margin-top: 1rem;\n}\n\n.edit__header {\n  flex-direction: column;\n  margin: 0;\n  margin-left: 1.5rem;\n}\n\n.main__container {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.main__col {\n  padding: 0;\n}\n\n.main__btns {\n  display: flex;\n}\n\n.main__edit,\n.main__view {\n  padding: 0.5rem 0;\n  margin: 1rem 0 0 0.2rem;\n}\n\n.main__view {\n  overflow: hidden;\n}\n\n.main__viewCol {\n  padding-left: 0;\n}\n\n.labelSettings__container {\n  padding-left: 0;\n}\n\n.currentItem__active {\n  min-width: 20%;\n}\n\n.currentItem__title {\n  font-weight: 700;\n}\n\n.preview__container {\n  width: 22rem;\n  height: 20rem;\n  padding: 0 1rem;\n}\n\n.m-0{\n  margin: 0 !important;\n}\n\n.ml-8{\n  margin-left: 0.5rem !important;\n}\n\n.mr-8{\n  margin-right: 0.5rem !important;\n}\n";
styleInject(css_248z$5);

var css_248z$4 = ".editProps__font {\n  width: 75%;\n}\n\n.editProp__layering--withoutFont {\n  margin: 0.5rem auto 0 auto;\n}\n\n.editProps__align {\n  text-align: center;\n  margin-bottom: 1rem;\n}\n";
styleInject(css_248z$4);

var css_248z$3 = ".font__container {\n  color: black;\n  display: flex;\n }\n\n.font__items {\n  text-align: center;\n  margin: 1rem auto;\n  display: flex;\n}\n\n.font__item {\n  margin: 0 1rem;\n}\n\n.font__btn {\n  margin: 0 0.2rem;\n  position: relative;\n}\n\n.font__btn--active {\n  background-color: rgba(0, 0, 0, 0.08);\n  border-radius: 50%;\n}\n\n.font__icon {\n  min-width: 15px;\n  font-size: 1rem;\n  background-color: unset !important;\n  color: #00000088 !important;\n  border: none !important;\n}\n\n.font__toggle {\n  color: inherit;\n  background-color: white;\n}\n\n.colorPicker {\n  position: absolute;\n  top: 1rem;\n  left: 1rem;\n  z-index: 1;\n}\n\n.font__fontFamily {\n  width: 150px;\n  margin-right: 0.1rem;\n}\n\n.font__fontSize {\n  width: 80px;\n}\n";
styleInject(css_248z$3);

function ownKeys$6(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$6(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$6(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$6(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$4(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$4() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$4() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$4 = function _isNativeReflectConstruct() { return !!t; })(); }
var fontFamily = ['Noto Sans', 'Times New Roman', 'Arial'];
var fontSize = [8, 10, 12, 14, 16, 18, 20, 22, 24];
var FontStyle = /*#__PURE__*/function (_Component) {
  function FontStyle() {
    var _this;
    _classCallCheck(this, FontStyle);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$4(this, FontStyle, [].concat(args));
    _defineProperty(_this, "state", {
      fontFamily: {
        value: 'Noto Sans',
        dropDownFontOpen: false
      },
      fontSize: {
        value: 12,
        dropDownSizeOpen: false
      },
      showColorPicker: false
    });
    _defineProperty(_this, "selectFont", function (_ref) {
      var value = _ref.value;
      _this.setState(_objectSpread$6(_objectSpread$6({}, _this.state), {}, {
        fontFamily: _objectSpread$6(_objectSpread$6({}, _this.state.fontFamily), {}, {
          value: value
        })
      }));
      _this.props.updateItem(_objectSpread$6(_objectSpread$6({}, _this.props.item), {}, {
        fontFamily: value
      }));
    });
    _defineProperty(_this, "selectSize", function (_ref2) {
      var value = _ref2.value;
      _this.setState(_objectSpread$6(_objectSpread$6({}, _this.state), {}, {
        fontSize: _objectSpread$6(_objectSpread$6({}, _this.state.fontSize), {}, {
          value: Number(value)
        })
      }));
      _this.props.updateItem(_objectSpread$6(_objectSpread$6({}, _this.props.item), {}, {
        fontSize: Number(value)
      }));
    });
    _defineProperty(_this, "toggleFontstyle", function (value) {
      var _this$props = _this.props,
        item = _this$props.item,
        updateItem = _this$props.updateItem;
      item && item.fontStyle ? item.fontStyle.includes(value) ? updateItem(_objectSpread$6(_objectSpread$6({}, item), {}, {
        fontStyle: item.fontStyle.replace(value, '')
      })) : updateItem(_objectSpread$6(_objectSpread$6({}, item), {}, {
        fontStyle: item.fontStyle + ' ' + value
      })) : updateItem(_objectSpread$6(_objectSpread$6({}, item), {}, {
        fontStyle: value
      }));
    });
    _defineProperty(_this, "toggleUnderline", function (value) {
      var _this$props2 = _this.props,
        item = _this$props2.item,
        updateItem = _this$props2.updateItem;
      item && item.textDecoration ? item.textDecoration.includes(value) && updateItem(_objectSpread$6(_objectSpread$6({}, item), {}, {
        textDecoration: ''
      })) : updateItem(_objectSpread$6(_objectSpread$6({}, item), {}, {
        textDecoration: value
      }));
    });
    _defineProperty(_this, "toggleColorPicker", function () {
      _this.setState(function (prevState) {
        return {
          showColorPicker: !prevState.showColorPicker
        };
      });
    });
    _defineProperty(_this, "setWrapperRef", function (node) {
      _this.wrapperRef = node;
    });
    _defineProperty(_this, "handleClickOutside", function (event) {
      if (_this.wrapperRef && !_this.wrapperRef.contains(event.target)) {
        _this.setState(_objectSpread$6(_objectSpread$6({}, _this.state), {}, {
          showColorPicker: false
        }));
      }
    });
    _defineProperty(_this, "handleTextColorChange", function (color) {
      var _this$props3 = _this.props,
        item = _this$props3.item,
        updateItem = _this$props3.updateItem;
      updateItem(_objectSpread$6(_objectSpread$6({}, item), {}, {
        color: color.hex
      }));
    });
    return _this;
  }
  _inherits(FontStyle, _Component);
  return _createClass(FontStyle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var boldBtn, italicBtn, underlineBtn;
      if (this.props.item) {
        underlineBtn = classnames({
          'font__btn--active': this.props.item.textDecoration === 'underline'
        });
        boldBtn = classnames({
          'font__btn--active': this.props.item.fontStyle ? this.props.item.fontStyle.includes('bold') : false
        });
        italicBtn = classnames({
          'font__btn--active': this.props.item.fontStyle ? this.props.item.fontStyle.includes('italic') : false
        });
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "font__container"
      }, /*#__PURE__*/React.createElement(Select, {
        className: "font__fontFamily",
        value: this.props.item ? {
          value: this.props.item.fontFamily,
          label: this.props.item.fontFamily
        } : {
          value: '',
          label: ''
        },
        options: fontFamily.map(function (value) {
          return {
            value: value,
            label: value
          };
        }),
        onChange: this.selectFont,
        isDisabled: this.props.isDisabled
      }), /*#__PURE__*/React.createElement(Select, {
        className: "font__fontSize",
        value: this.props.item ? {
          value: this.props.item.fontSize,
          label: this.props.item.fontSize
        } : {
          value: '',
          label: ''
        },
        options: fontSize.map(function (value) {
          return {
            value: value,
            label: value
          };
        }),
        onChange: this.selectSize,
        isDisabled: this.props.isDisabled
      }), /*#__PURE__*/React.createElement("div", {
        className: boldBtn
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return _this2.toggleFontstyle('bold');
        },
        className: "font__icon",
        disabled: this.props.isDisabled
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: "bold"
      }))), /*#__PURE__*/React.createElement("div", {
        className: italicBtn
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return _this2.toggleFontstyle('italic');
        },
        className: "font__icon",
        disabled: this.props.isDisabled
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: "italic"
      }))), /*#__PURE__*/React.createElement("div", {
        className: underlineBtn
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return _this2.toggleUnderline('underline');
        },
        className: "font__icon",
        disabled: this.props.isDisabled
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: "underline"
      }))));
    }
  }]);
}(Component);
FontStyle.propTypes = {
  item: PropTypes.object,
  updateItem: PropTypes.func,
  isDisabled: PropTypes.bool
};

var alignBottom = "data:image/svg+xml,%3Csvg%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20focusable%3D%22false%22%20viewBox%3D%220%200%2024%2024%22%20aria-hidden%3D%22true%22%3E%3Cpath%20d%3D%22M16%2013h-3V3h-2v10H8l4%204%204-4zM4%2019v2h16v-2H4z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

var alignCenter = "data:image/svg+xml,%3Csvg%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20%20focusable%3D%22false%22%20viewBox%3D%220%200%2024%2024%22%20aria-hidden%3D%22true%22%3E%3Cpath%20d%3D%22M8%2019h3v4h2v-4h3l-4-4-4%204zm8-14h-3V1h-2v4H8l4%204%204-4zM4%2011v2h16v-2H4z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

var alignTop = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20viewBox%3D%220%200%2024%2024%22%20aria-hidden%3D%22true%22%3E%3Cpath%20d%3D%22M8%2011h3v10h2V11h3l-4-4-4%204zM4%203v2h16V3H4z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

var bringtoFront = "data:image/svg+xml,%3Csvg%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20focusable%3D%22false%22%20viewBox%3D%220%200%2024%2024%22%20aria-hidden%3D%22true%22%3E%3Cpath%20d%3D%22M3%2013h2v-2H3v2zm0%204h2v-2H3v2zm2%204v-2H3c0%201.1.89%202%202%202zM3%209h2V7H3v2zm12%2012h2v-2h-2v2zm4-18H9c-1.11%200-2%20.9-2%202v10c0%201.1.89%202%202%202h10c1.1%200%202-.9%202-2V5c0-1.1-.9-2-2-2zm0%2012H9V5h10v10zm-8%206h2v-2h-2v2zm-4%200h2v-2H7v2z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

var bringtoBack = "data:image/svg+xml,%3Csvg%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20focusable%3D%22false%22%20viewBox%3D%220%200%2024%2024%22%20aria-hidden%3D%22true%22%3E%3Cpath%20d%3D%22M9%207H7v2h2V7zm0%204H7v2h2v-2zm0-8c-1.11%200-2%20.9-2%202h2V3zm4%2012h-2v2h2v-2zm6-12v2h2c0-1.1-.9-2-2-2zm-6%200h-2v2h2V3zM9%2017v-2H7c0%201.1.89%202%202%202zm10-4h2v-2h-2v2zm0-4h2V7h-2v2zm0%208c1.1%200%202-.9%202-2h-2v2zM5%207H3v12c0%201.1.89%202%202%202h12v-2H5V7zm10-2h2V3h-2v2zm0%2012h2v-2h-2v2z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

var moveUp = "data:image/svg+xml,%3Csvg%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20focusable%3D%22false%22%20viewBox%3D%220%200%2024%2024%22%20aria-hidden%3D%22true%22%3E%3Cpath%20d%3D%22M12%208l-6%206%201.41%201.41L12%2010.83l4.59%204.58L18%2014z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

var moveDown = "data:image/svg+xml,%3Csvg%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20focusable%3D%22false%22%20viewBox%3D%220%200%2024%2024%22%20aria-hidden%3D%22true%22%3E%3Cpath%20d%3D%22M16.59%208.59L12%2013.17%207.41%208.59%206%2010l6%206%206-6z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

function ownKeys$5(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$5(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$5(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$5(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Alignments = function Alignments(props) {
  var item = props.item,
    updateItem = props.updateItem,
    moveItemBottom = props.moveItemBottom,
    moveItemDown = props.moveItemDown,
    moveItemTop = props.moveItemTop,
    moveItemUp = props.moveItemUp;
  var alignItem = function alignItem(align) {
    var changedItem = {};
    switch (align) {
      case 'right':
      case 'center':
      case 'left':
        changedItem = _objectSpread$5(_objectSpread$5({}, item), {}, {
          align: align
        });
        break;
      case 'top':
      case 'middle':
      case 'bottom':
        changedItem = _objectSpread$5(_objectSpread$5({}, item), {}, {
          verticalAlign: align
        });
        break;
    }
    updateItem(changedItem);
  };
  var moveItemLayer = function moveItemLayer(direction) {
    switch (direction) {
      case 'down':
        moveItemDown(item);
        break;
      case 'up':
        moveItemUp(item);
        break;
      case 'bottom':
        moveItemBottom(item);
        break;
      case 'top':
        moveItemTop(item);
        break;
    }
  };
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Col, {
    xs: 'auto',
    style: {
      display: 'flex',
      padding: 0,
      maxWidth: '560px'
    }
  }, /*#__PURE__*/React.createElement(FontStyle, {
    isDisabled: !item || item.itemType !== ITEM_TEXT && item.itemType !== ITEM_VARIABLE,
    item: item,
    updateItem: updateItem
  }), /*#__PURE__*/React.createElement(Button, {
    className: "font__icon",
    title: "Align text to left",
    disabled: !item || item.itemType !== ITEM_TEXT && item.itemType !== ITEM_VARIABLE,
    onClick: function onClick() {
      return alignItem('left');
    }
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "align-left"
  })), /*#__PURE__*/React.createElement(Button, {
    className: "font__icon",
    title: "Align text to center",
    onClick: function onClick() {
      return alignItem('center');
    },
    disabled: !item || item.itemType !== ITEM_TEXT && item.itemType !== ITEM_VARIABLE
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "align-center"
  })), /*#__PURE__*/React.createElement(Button, {
    className: "font__icon",
    title: "Align text to right",
    onClick: function onClick() {
      return alignItem('right');
    },
    disabled: !item || item.itemType !== ITEM_TEXT && item.itemType !== ITEM_VARIABLE
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "align-right"
  })), /*#__PURE__*/React.createElement(Button, {
    className: "font__icon",
    title: "Align text to top",
    onClick: function onClick() {
      return alignItem('top');
    },
    disabled: !item || item.itemType !== ITEM_TEXT && item.itemType !== ITEM_VARIABLE
  }, /*#__PURE__*/React.createElement("img", {
    width: 20,
    height: 20,
    src: alignTop,
    alt: "align top"
  })), /*#__PURE__*/React.createElement(Button, {
    className: "font__icon",
    title: "Align text to middle",
    onClick: function onClick() {
      return alignItem('middle');
    },
    disabled: !item || item.itemType !== ITEM_TEXT && item.itemType !== ITEM_VARIABLE
  }, /*#__PURE__*/React.createElement("img", {
    width: 20,
    height: 20,
    src: alignCenter,
    alt: "align center"
  })), /*#__PURE__*/React.createElement(Button, {
    className: "font__icon",
    title: "Align text to bottom",
    onClick: function onClick() {
      return alignItem('bottom');
    },
    disabled: !item || item.itemType !== ITEM_TEXT && item.itemType !== ITEM_VARIABLE
  }, /*#__PURE__*/React.createElement("img", {
    width: 20,
    height: 20,
    src: alignBottom,
    alt: "align bottom"
  }))), /*#__PURE__*/React.createElement(Col, {
    xs: 'auto',
    style: {
      padding: 0,
      display: 'flex',
      maxWidth: '160px'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    className: "font__icon",
    title: "Bring to front",
    onClick: function onClick() {
      return moveItemLayer('top');
    },
    disabled: !item
  }, /*#__PURE__*/React.createElement("img", {
    width: 20,
    height: 20,
    src: bringtoFront,
    alt: "missing"
  })), /*#__PURE__*/React.createElement(Button, {
    className: "font__icon",
    title: "Move up",
    onClick: function onClick() {
      return moveItemLayer('up');
    },
    disabled: !item
  }, /*#__PURE__*/React.createElement("img", {
    width: 20,
    height: 20,
    src: moveUp,
    alt: "missing"
  })), /*#__PURE__*/React.createElement(Button, {
    className: "font__icon",
    title: "Move down",
    onClick: function onClick() {
      return moveItemLayer('down');
    },
    disabled: !item
  }, /*#__PURE__*/React.createElement("img", {
    width: 20,
    height: 20,
    src: moveDown,
    alt: "missing"
  })), /*#__PURE__*/React.createElement(Button, {
    className: "font__icon",
    title: "Bring to back",
    onClick: function onClick() {
      return moveItemLayer('bottom');
    },
    disabled: !item
  }, /*#__PURE__*/React.createElement("img", {
    width: 20,
    height: 20,
    src: bringtoBack,
    alt: "missing"
  }))));
};
Alignments.propTypes = {
  item: PropTypes.object,
  updateItem: PropTypes.func,
  moveItemDown: PropTypes.func,
  moveItemUp: PropTypes.func,
  moveItemTop: PropTypes.func,
  moveItemBottom: PropTypes.func
};

var css_248z$2 = ".editor__container {\n  /* width: 26rem; */\n  height: 7rem;\n}\n\n.editor__field {\n  background-color: white;\n}\n\n.editor__scrollbar {\n  height: calc(100vh - 120px - 10rem);\n  overflow: auto;\n}\n\n.editor__scrollbar::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: rgba(0, 0, 0, 0.1);\n  border-radius: 0.35rem;\n}\n\n.editor__scrollbar::-webkit-scrollbar {\n  width: 0.75rem;\n}\n\n.editor__scrollbar::-webkit-scrollbar-thumb {\n  background-color: white;\n  border-radius: 0.35rem;\n  border: 1px solid #cbd3da;\n}\n.editor__scrollbar::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n\n.editor__border {\n  border: 1px dashed blue;\n}\n";
styleInject(css_248z$2);

function ownKeys$4(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$4(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$4(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$3(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$3() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$3() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$3 = function _isNativeReflectConstruct() { return !!t; })(); }
var Editor = /*#__PURE__*/function (_Component) {
  function Editor(props) {
    var _this;
    _classCallCheck(this, Editor);
    _this = _callSuper$3(this, Editor, [props]);
    _defineProperty(_this, "handleDeleteItem", function (e) {
      if (e.key === 'Delete' && document.activeElement.type !== 'number' && _this.props.currentItem) {
        _this.props.deleteItem(_this.props.currentItem);
      }
    });
    _defineProperty(_this, "drop", function (e) {
      var rect = e.target.getBoundingClientRect();
      var x = e.clientX - (window.scrollX + rect.x);
      var y = e.clientY - (window.scrollY + rect.y);
      var data = e.dataTransfer.getData('text');
      _this.addItem(defaultItems[data], x, y);
    });
    _defineProperty(_this, "dragover", function (e) {
      e.preventDefault();
    });
    _this.stageref = /*#__PURE__*/React.createRef();
    _this.layerref = /*#__PURE__*/React.createRef();
    return _this;
  }
  _inherits(Editor, _Component);
  return _createClass(Editor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handleDeleteItem);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleDeleteItem);
    }
  }, {
    key: "addItem",
    value:
    /*bitmap for canvas
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const pixelImageData= ctx.createImageData(100,100);// creating new empty ImageData object
    const ImageData = ctx.getImageData(1,1,props.layout.width,props.layout.height);// getting a copy of the pixel data from canvas to imageData object
    const data = ImageData.data;
    */
    function addItem(item, x, y) {
      var newItem = _objectSpread$4(_objectSpread$4({}, item), {}, {
        x: x,
        y: y,
        id: this.props.items.length
      });
      this.props.createItem(newItem);
      this.props.selectItem(newItem.id);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        selectItem = _this$props.selectItem,
        updateItem = _this$props.updateItem,
        layout = _this$props.layout,
        selectedItemId = _this$props.selectedItemId,
        codeToInfo = _this$props.codeToInfo,
        move = _this$props.move;
      var itemsArray = layout.itemids.map(function (id) {
        return layout.items[id];
      });
      var widthGrid = gridGenerate(layout.width.pixel - layout.marginLeft - layout.marginRight, layout.height.pixel - layout.marginTop - layout.marginBottom, gridSize).widthLines;
      var heightGrid = gridGenerate(layout.width.pixel - layout.marginLeft - layout.marginRight, layout.height.pixel - layout.marginTop - layout.marginBottom, gridSize).heightLines;
      return /*#__PURE__*/React.createElement("div", {
        className: "editor__scrollbar"
      }, /*#__PURE__*/React.createElement("div", {
        className: "editor__field",
        style: {
          backgroundColor: 'white',
          height: layout.height.pixel,
          width: layout.width.pixel,
          paddingTop: layout.marginTop,
          paddingBottom: layout.marginBottom,
          paddingLeft: layout.marginLeft,
          paddingRight: layout.marginRight
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "editor__border",
        onDrop: this.drop,
        onDragOver: this.dragover,
        id: 'ep_editor_container'
      }, /*#__PURE__*/React.createElement(Stage, {
        height: layout.height.pixel - layout.marginTop - layout.marginBottom,
        width: layout.width.pixel - layout.marginLeft - layout.marginRight,
        id: "stage",
        ref: this.stageref,
        onClick: function onClick(event) {
          var thisstage = _this2.stageref.current;
          var thislayer = _this2.layerref.current;
          if (event.target === thisstage) {
            _this2.props.selectItem(null);
            //thisstage.find('Transformer').destroy();
            thislayer.draw();
            return;
          }
        }
      }, /*#__PURE__*/React.createElement(Layer, {
        ref: this.layerref
      }, widthGrid, heightGrid, itemsArray.map(function (item) {
        return /*#__PURE__*/React.createElement(Item, {
          key: item.id,
          item: item,
          varInfo: codeToInfo[item.varCode]
          //{props.uploads.map((upload) => <Item key={upload.id} upload={upload}
          ,
          layout: layout,
          selectItem: selectItem,
          updateItem: updateItem,
          selectedItemId: selectedItemId,
          codeToInfo: codeToInfo,
          move: move
        });
      }))))));
    }
  }]);
}(Component);
Editor.propTypes = {
  currentItem: PropTypes.object,
  selectItem: PropTypes.func.isRequired,
  createItem: PropTypes.func.isRequired,
  updateItem: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.object),
  width: PropTypes.number,
  height: PropTypes.number,
  layout: PropTypes.object,
  updatePage: PropTypes.func,
  updateReadOnly: PropTypes.func,
  selectedItemId: PropTypes.number,
  codeToInfo: PropTypes.object,
  move: PropTypes.bool,
  deleteItem: PropTypes.func
};

var css_248z$1 = ".labelItem__title {\n  font-weight: 700;\n}\n\n.labelItem__title--horizontal {\n  width: 70%;\n  font-weight: 700;\n}\n\n.labelItem__text {\n  display: flex;\n  margin: 1rem 0;\n}\n\n.labelItem__position {\n  margin-top: 1rem;\n}\n\n.labelItem__inputs {\n  display: flex;\n  margin: 1rem 0;\n}\n\n.labelItem__inputs--line {\n  width: 50%;\n}\n\n.labelItem__dropdown {\n  margin-left: 2.5rem;\n}\n\n.labelItem__toggle {\n  color: inherit;\n  background-color: white;\n}\n";
styleInject(css_248z$1);

var _excluded$1 = ["top"];
function _callSuper$2(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$2() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$2() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$2 = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys$3(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$3(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var rotations = ['0', '90', '180', '270'];
var selectStyles$1 = {
  menu: function menu(_ref, _) {
    _ref.top;
      var remains = _objectWithoutProperties(_ref, _excluded$1);
    return _objectSpread$3({}, remains);
  }
};
var labelItemsSettings = /*#__PURE__*/function (_Component) {
  function labelItemsSettings() {
    var _this;
    _classCallCheck(this, labelItemsSettings);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$2(this, labelItemsSettings, [].concat(args));
    _defineProperty(_this, "customWidth", function (e) {
      var num = Number(e.target.value);
      if (!isNaN(num)) {
        num = mmToPixel(num);
        var item = _objectSpread$3(_objectSpread$3({}, _this.props.item), {}, {
          width: num
        });
        _this.props.updateItem(item);
      }
    });
    _defineProperty(_this, "customHeight", function (e) {
      var num = Number(e.target.value);
      if (!isNaN(num)) {
        num = mmToPixel(num);
        var item = _objectSpread$3(_objectSpread$3({}, _this.props.item), {}, {
          height: num
        });
        _this.props.updateItem(item);
      }
    });
    _defineProperty(_this, "customPositionLeft", function (e) {
      var num = Number(e.target.value);
      if (!isNaN(num)) {
        num = mmToPixel(num);
        var item = _objectSpread$3(_objectSpread$3({}, _this.props.item), {}, {
          x: num
        });
        _this.props.updateItem(item);
      }
    });
    _defineProperty(_this, "customPositionTop", function (e) {
      var num = Number(e.target.value);
      if (!isNaN(num)) {
        num = mmToPixel(num);
        var item = _objectSpread$3(_objectSpread$3({}, _this.props.item), {}, {
          y: num
        });
        _this.props.updateItem(item);
      }
    });
    return _this;
  }
  _inherits(labelItemsSettings, _Component);
  return _createClass(labelItemsSettings, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (this.props.item !== nextProps.item || this.props.layout.marginTop !== nextProps.layout.marginTop || this.props.layout.marginBottom !== nextProps.layout.marginBottom || this.props.layout.marginLeft !== nextProps.layout.marginLeft || this.props.layout.marginRight !== nextProps.layout.marginRight) {
        return true;
      }
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        t = _this$props.t,
        item = _this$props.item,
        rotationSnaps = _this$props.rotationSnaps;
      var sizeInputs = classnames('labelItem__inputs', {
        'labelItem__inputs--line': false
      });
      var itemSettings = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "labelItem__position"
      }, /*#__PURE__*/React.createElement("p", {
        className: "labelItem__title margin-0"
      }, t('lbl.positionFrom', 'Position from')), /*#__PURE__*/React.createElement("div", {
        className: "labelItem__inputs"
      }, /*#__PURE__*/React.createElement(customInput, {
        type: "number",
        disabled: !item,
        onChange: this.customPositionLeft,
        value: item ? pixelToMm(Math.round(item.x)) === 0 ? '' : pixelToMm(Math.round(item.x)) : '',
        inputSize: "md",
        variant: "vertical",
        labelText: t('lbl.leftMargin', 'Left')
      }), /*#__PURE__*/React.createElement(customInput, {
        type: "number",
        disabled: !item,
        onChange: this.customPositionTop,
        value: item ? pixelToMm(Math.round(item.y)) === 0 ? '' : pixelToMm(Math.round(item.y)) : '',
        inputSize: "md",
        variant: "vertical",
        labelText: t('lbl.topMargin', 'Top')
      }))), /*#__PURE__*/React.createElement("div", {
        className: "labelItem__size"
      }, /*#__PURE__*/React.createElement("p", {
        className: "labelItem__title margin-0"
      }, t('lbl.size_itemOnLabel', 'Size')), /*#__PURE__*/React.createElement("div", {
        className: sizeInputs
      }, /*#__PURE__*/React.createElement(customInput, {
        type: "number",
        disabled: !item,
        onChange: this.customWidth,
        value: item ? pixelToMm(Math.round(item.width)) === 0 ? '' : pixelToMm(Math.round(item.width)) : '',
        inputSize: "md",
        variant: "vertical",
        labelText: t('lbl.width', 'Width')
      }), /*#__PURE__*/React.createElement(customInput, {
        type: "number",
        disabled: !item || item && item.itemType === 'line',
        onChange: this.customHeight,
        value: item ? pixelToMm(Math.round(item.height)) === 0 ? '' : pixelToMm(Math.round(item.height)) : '',
        inputSize: "md",
        variant: "vertical",
        labelText: t('lbl.height', 'Height')
      }))), /*#__PURE__*/React.createElement("div", {
        className: "labelItem__position"
      }, /*#__PURE__*/React.createElement("p", {
        className: "labelItem__title margin-0"
      }, t('lbl.rotation', 'Rotation')), /*#__PURE__*/React.createElement("div", {
        className: "labelItem__inputs"
      }, /*#__PURE__*/React.createElement(Select, {
        styles: selectStyles$1,
        className: "typeSettings__select--inline",
        disabled: !item,
        value: item !== null && item !== void 0 && item.rotation ? {
          value: item.rotation.toString(),
          label: item.rotation.toString()
        } : {
          value: '0',
          label: '0'
        },
        options: rotations.map(function (deg) {
          return {
            value: deg,
            label: deg
          };
        }),
        onChange: rotationSnaps
      }))), (item === null || item === void 0 ? void 0 : item.itemType) === ITEM_BARCODE && /*#__PURE__*/React.createElement("div", {
        className: "labelItem__position"
      }, /*#__PURE__*/React.createElement("p", {
        className: "labelItem__title margin-0"
      }, t('lbl.showText', 'Show text')), /*#__PURE__*/React.createElement("div", {
        className: "labelItem__inputs"
      }, /*#__PURE__*/React.createElement(customInput, {
        type: "checkbox",
        disabled: !item,
        onChange: function onChange(e) {
          var item = _objectSpread$3(_objectSpread$3({}, _this2.props.item), {}, {
            showText: e.target.checked
          });
          _this2.props.updateItem(item);
        },
        checked: item !== null && item !== void 0 && item.showText ? item.showText : false,
        inputSize: "md",
        variant: "vertical",
        width: "1.25rem"
      }))));
      return /*#__PURE__*/React.createElement(React.Fragment, null, itemSettings);
    }
  }]);
}(Component);
labelItemsSettings.propTypes = {
  t: PropTypes.func.isRequired,
  item: PropTypes.object,
  layout: PropTypes.object,
  updateItem: PropTypes.func.isRequired,
  rotationSnaps: PropTypes.func
};
var LabelItemsSettings = withTranslation('translations')(labelItemsSettings);

var css_248z = ".typeSettings__title {\n  font-weight: 700;\n}\n\n.typeSettings__title--horizontal {\n  font-weight: 700;\n}\n\n.typeSettings__text {\n  display: flex;\n  flex-direction: column;\n  width: 80%;\n}\n\n.typeSettings__position {\n  margin-top: 1rem;\n}\n\n.typeSettings__inputs {\n  width: 60%;\n  display: flex;\n  flex-direction: column;\n}\n\n.typeSettings__inputs--value {\n  width: 40%;\n  margin-right: 2rem;\n}\n\n.typeSettings__dropdown {\n  margin-left: 3rem;\n}\n\n.typeSettings__toggle {\n  color: inherit;\n  background-color: white;\n  padding-right: 1rem;\n  width: 100%;\n  overflow: auto;\n}\n\n.typeSettings__customText {\n  width: 50%;\n}\n\n.typeSettings__prompt {\n  width: 80%;\n}\n\n.prompt__text {\n }\n\n.typeSettings__select--inline {\n\n}\n";
styleInject(css_248z);

var _excluded = ["top"];
function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var barcodes = [BARCODE_EAN8, BARCODE_EAN13, BARCODE_CODE39, BARCODE_CODE128, BARCODE_UPCA, BARCODE_GS_128, BARCODE_QRCODE];
var TYPE_NAME_MAP = {
  auspost: 'AusPost 4 State Customer Code',
  azteccode: 'Aztec Code',
  azteccodecompact: 'Compact Aztec Code',
  aztecrune: 'Aztec Runes',
  bc412: 'BC412',
  channelcode: 'Channel Code',
  codablockf: 'Codablock F',
  code11: 'Code 11',
  code128: 'Code 128',
  code16k: 'Code 16K',
  code2of5: 'Code 25',
  code32: 'Italian Pharmacode',
  code39: 'Code 39',
  code39ext: 'Code 39 Extended',
  code49: 'Code 49',
  code93: 'Code 93',
  code93ext: 'Code 93 Extended',
  codeone: 'Code One',
  coop2of5: 'COOP 2 of 5',
  daft: 'Custom 4 state symbology',
  databarexpanded: 'GS1 DataBar Expanded',
  databarexpandedcomposite: 'GS1 DataBar Expanded Composite',
  databarexpandedstacked: 'GS1 DataBar Expanded Stacked',
  databarexpandedstackedcomposite: 'GS1 DataBar Expanded Stacked Composite',
  databarlimited: 'GS1 DataBar Limited',
  databarlimitedcomposite: 'GS1 DataBar Limited Composite',
  databaromni: 'GS1 DataBar Omnidirectional',
  databaromnicomposite: 'GS1 DataBar Omnidirectional Composite',
  databarstacked: 'GS1 DataBar Stacked',
  databarstackedcomposite: 'GS1 DataBar Stacked Composite',
  databarstackedomni: 'GS1 DataBar Stacked Omnidirectional',
  databarstackedomnicomposite: 'GS1 DataBar Stacked Omnidirectional Composite',
  databartruncated: 'GS1 DataBar Truncated',
  databartruncatedcomposite: 'GS1 DataBar Truncated Composite',
  datalogic2of5: 'Datalogic 2 of 5',
  datamatrix: 'Data Matrix',
  datamatrixrectangular: 'Data Matrix Rectangular',
  datamatrixrectangularextension: 'Data Matrix Rectangular Extension',
  dotcode: 'DotCode',
  ean13: 'EAN-13',
  ean13composite: 'EAN-13 Composite',
  ean14: 'GS1-14',
  ean2: 'EAN-2 (2 digit addon)',
  ean5: 'EAN-5 (5 digit addon)',
  ean8: 'EAN-8',
  ean8composite: 'EAN-8 Composite',
  flattermarken: 'Flattermarken',
  'gs1-128': 'GS1-128',
  'gs1-128composite': 'GS1-128 Composite',
  'gs1-cc': 'GS1 Composite 2D Component',
  gs1datamatrix: 'GS1 Data Matrix',
  gs1datamatrixrectangular: 'GS1 Data Matrix Rectangular',
  gs1dotcode: 'GS1 DotCode',
  gs1northamericancoupon: 'GS1 North American Coupon',
  gs1qrcode: 'GS1 QR Code',
  hanxin: 'Han Xin Code',
  hibcazteccode: 'HIBC Aztec Code',
  hibccodablockf: 'HIBC Codablock F',
  hibccode128: 'HIBC Code 128',
  hibccode39: 'HIBC Code 39',
  hibcdatamatrix: 'HIBC Data Matrix',
  hibcdatamatrixrectangular: 'HIBC Data Matrix Rectangular',
  hibcmicropdf417: 'HIBC MicroPDF417',
  hibcpdf417: 'HIBC PDF417',
  hibcqrcode: 'HIBC QR Code',
  iata2of5: 'IATA 2 of 5',
  identcode: 'Deutsche Post Identcode',
  industrial2of5: 'Industrial 2 of 5',
  interleaved2of5: 'Interleaved 2 of 5 (ITF)',
  isbn: 'ISBN',
  ismn: 'ISMN',
  issn: 'ISSN',
  itf14: 'ITF-14',
  japanpost: 'Japan Post 4 State Customer Code',
  kix: 'Royal Dutch TPG Post KIX',
  leitcode: 'Deutsche Post Leitcode',
  mailmark: 'Royal Mail Mailmark',
  matrix2of5: 'Matrix 2 of 5',
  maxicode: 'MaxiCode',
  micropdf417: 'MicroPDF417',
  microqrcode: 'Micro QR Code',
  msi: 'MSI Modified Plessey',
  onecode: 'USPS Intelligent Mail',
  pdf417: 'PDF417',
  pdf417compact: 'Compact PDF417',
  pharmacode: 'Pharmaceutical Binary Code',
  pharmacode2: 'Two-track Pharmacode',
  planet: 'USPS PLANET',
  plessey: 'Plessey UK',
  posicode: 'PosiCode',
  postnet: 'USPS POSTNET',
  pzn: 'Pharmazentralnummer (PZN)',
  qrcode: 'QR Code',
  rationalizedCodabar: 'Codabar',
  raw: 'Custom 1D symbology',
  rectangularmicroqrcode: 'Rectangular Micro QR Code',
  royalmail: 'Royal Mail 4 State Customer Code',
  sscc18: 'SSCC-18',
  symbol: 'Miscellaneous symbols',
  telepen: 'Telepen',
  telepennumeric: 'Telepen Numeric',
  ultracode: 'Ultracode',
  upca: 'UPC-A',
  upcacomposite: 'UPC-A Composite',
  upce: 'UPC-E',
  upcecomposite: 'UPC-E Composite'
};
var strokeAndCorner = ['0', '2', '4', '6', '8', '10'];
var selectStyles = {
  menu: function menu(_ref, _) {
    _ref.top;
      var remains = _objectWithoutProperties(_ref, _excluded);
    return _objectSpread$2({}, remains);
  }
};
var TypeSettings = function TypeSettings(props) {
  var t = props.t,
    item = props.item,
    writeText = props.writeText,
    customText = props.customText,
    toggleCustomText = props.toggleCustomText,
    customStrokeWidth = props.customStrokeWidth,
    customCornerCurve = props.customCornerCurve,
    customVariableGroup = props.customVariableGroup,
    customVariable = props.customVariable,
    customBarcode = props.customBarcode,
    customBarcodeType = props.customBarcodeType,
    writePrompt = props.writePrompt,
    variableGroup = props.variableGroup,
    barcodeVariables = props.barcodeVariables,
    customBarcodeGroup = props.customBarcodeGroup,
    codeToInfo = props.codeToInfo;
  var typeSettings = null;
  if (item) {
    switch (item.itemType) {
      case ITEM_IMAGE:
        break;
      case ITEM_TEXT:
        typeSettings = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, {
          style: {
            maxWidth: '100px'
          }
        }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
          className: "typeSettings__title--horizontal margin-0"
        }, t('lbl.custom_cansize', 'Custom')))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
          style: {
            paddingTop: '7px'
          }
        }, /*#__PURE__*/React.createElement(Input, {
          type: "checkbox",
          id: "exampleCustomCheckbox3",
          checked: toggleCustomText,
          onChange: customText
        })))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
          className: "typeSettings__title margin-0"
        }, toggleCustomText ? t('lbl.customText', 'Custom Text') : t('lbl.text', 'Text')))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, toggleCustomText ? /*#__PURE__*/React.createElement(Input, {
          value: item.prompt,
          onChange: function onChange(e) {
            return writePrompt(e);
          },
          placeholder: t('prompt.enterPrompt', 'Enter prompt'),
          className: "prompt__text"
        }) : /*#__PURE__*/React.createElement(Input, {
          value: item.text,
          onChange: function onChange(e) {
            return writeText(e);
          },
          placeholder: t('prompt.enterStaticText', 'Enter static text'),
          className: "prompt__text"
        })))));
        break;
      case ITEM_VARIABLE:
        try {
          var info = codeToInfo[item.varCode];
          var label = info ? info.label : '';
          var group = info ? variableGroup.find(function (el) {
            return el.code === info.group;
          }) : null;
          typeSettings = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
            className: "typeSettings__title margin-0"
          }, t('lbl.variableGroup', 'Variable Group')), /*#__PURE__*/React.createElement(Select, {
            styles: selectStyles,
            value: group ? {
              value: group.label,
              label: group.label
            } : {
              value: '',
              label: t('lbl.group', 'Group')
            },
            options: variableGroup.map(function (group) {
              return {
                value: group.label,
                label: group.label
              };
            }),
            onChange: customVariableGroup
          })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
            className: "typeSettings__title margin-0"
          }, t('lbl.variable', 'Variable')))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Select, {
            styles: selectStyles,
            value: {
              value: "[".concat(item.varCode, "]"),
              label: "[".concat(label, "]")
            },
            options: group && group.variables.map(function (variable) {
              return {
                value: variable.code,
                label: variable.label
              };
            }),
            onChange: customVariable
          })))));
        } catch (e) {
          console.log(e);
        }
        break;
      case ITEM_BARCODE:
        try {
          var _info = codeToInfo[item.varCode];
          var _label = _info ? _info.label : '';
          var _group = _info ? barcodeVariables.find(function (el) {
            return el.code === _info.group;
          }) : null;
          var variables = _group ? _group.variables.filter(function (x) {
            return item.type === BARCODE_QRCODE ? x.barcode_types.includes(BARCODE_QRCODE) : x.barcode_types.filter(function (y) {
              return y !== BARCODE_QRCODE;
            }).length > 0;
          }) : [];
          var variable_barcode_types = _info ? (_info.barcode_types ? _info.barcode_types : barcodes).filter(function (x) {
            return item.type === BARCODE_QRCODE ? x === BARCODE_QRCODE : x !== BARCODE_QRCODE;
          }) : [];

          // Update the type to be correct one if there is only one type available or the type is not valid
          if (variable_barcode_types.length > 0 && item) {
            if (item.type !== variable_barcode_types[0] && variable_barcode_types.length === 1 || !variable_barcode_types.includes(item.type)) {
              setTimeout(function () {
                customBarcodeType({
                  value: variable_barcode_types[0]
                });
              }, 300);
            }
          }
          typeSettings = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
            className: "typeSettings__title margin-0"
          }, t('lbl.barcodeGroup', 'Barcode Group')))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Select, {
            value: _group ? {
              value: _group.label,
              label: _group.label
            } : {
              value: '',
              label: t('lbl.group', 'Group')
            },
            options: barcodeVariables.map(function (group) {
              return {
                value: group.label,
                label: group.label
              };
            }),
            onChange: customBarcodeGroup
          })))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
            className: "typeSettings__title margin-0"
          }, t('lbl.variable', 'Variable')))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Select, {
            isDisabled: variables.length === 0,
            value: {
              value: item.varCode,
              label: _label
            },
            options: variables.map(function (variable) {
              return {
                value: variable.code,
                label: variable.label
              };
            }),
            onChange: customBarcode
          })))), /*#__PURE__*/React.createElement(Col, null, item.type !== BARCODE_QRCODE && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
            className: "typeSettings__title margin-0"
          }, t('lbl.barcodeType', 'Barcode type')))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Select, {
            isDisabled: !_info,
            styles: selectStyles,
            value: variable_barcode_types.includes(item.type) ? {
              value: item.type,
              label: TYPE_NAME_MAP[item.type] || item.type.toUpperCase()
            } : {
              value: '',
              label: ''
            },
            options: variable_barcode_types.map(function (value) {
              return {
                value: value,
                label: TYPE_NAME_MAP[value] || value.toUpperCase()
              };
            }),
            onChange: customBarcodeType
          }))))));
        } catch (e) {
          console.log(e);
        }
        break;
      case ITEM_LINE:
        typeSettings = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
          className: "typeSettings__title margin-0"
        }, t('lbl.lineWidth', 'Line Width')))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Select, {
          className: "typeSettings__select--inline",
          value: item.strokeWidth ? {
            value: item.strokeWidth,
            label: item.strokeWidth
          } : {
            value: '0',
            label: '0'
          },
          options: strokeAndCorner.map(function (value) {
            return {
              value: value,
              label: value
            };
          }),
          onChange: customStrokeWidth
        })))));
        break;
      case ITEM_RECTANGLE:
        typeSettings = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
          className: "typeSettings__title margin-0"
        }, t('lbl.lineWidth', 'Line Width')))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Select, {
          className: "typeSettings__select--inline",
          value: item.strokeWidth ? {
            value: item.strokeWidth,
            label: item.strokeWidth
          } : {
            value: '0',
            label: '0'
          },
          options: strokeAndCorner.map(function (value) {
            return {
              value: value,
              label: value
            };
          }),
          onChange: customStrokeWidth
        })))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
          className: "typeSettings__title margin-0"
        }, t('lbl.lineCurve', 'Line Curve')))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Select, {
          className: "typeSettings__select--inline",
          value: item.cornerRadius ? {
            value: item.cornerRadius,
            label: item.cornerRadius
          } : {
            value: '0',
            label: '0'
          },
          options: strokeAndCorner.map(function (value) {
            return {
              value: value,
              label: value
            };
          }),
          onChange: customCornerCurve
        })))));
        break;
      case ITEM_ELLIPSE:
        typeSettings = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
          className: "typeSettings__title margin-0"
        }, t('lbl.lineWidth', 'Line Width')))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Select, {
          className: "typeSettings__select--inline",
          value: item.strokeWidth ? {
            value: item.strokeWidth,
            label: item.strokeWidth
          } : {
            value: '0',
            label: '0'
          },
          options: strokeAndCorner.map(function (value) {
            return {
              value: value,
              label: value
            };
          }),
          onChange: customStrokeWidth
        })))));
        break;
    }
  }
  return typeSettings;
};
var TypeSettings$1 = withTranslation('translations')(TypeSettings);

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$1(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1 = function _isNativeReflectConstruct() { return !!t; })(); }
var DEFAULT_PRINTER = 'DEFAULT_PRINTER';
var Layout = /*#__PURE__*/function (_Component) {
  function Layout(props) {
    var _this;
    _classCallCheck(this, Layout);
    _this = _callSuper$1(this, Layout, [props]);
    _defineProperty(_this, "updatePrintersList", function (str) {
      var t = _this.props.t;
      var printers = JSON.parse(str);
      _this.printers = printers.available.map(function (x) {
        return {
          label: x,
          value: x
        };
      });
      _this.printers.unshift({
        label: '<' + t('lbl.systemDefault', 'System default') + '>',
        value: null
      });
    });
    _defineProperty(_this, "customStrokeWidth", function (e) {
      var item = _objectSpread$1(_objectSpread$1({}, _this.props.item), {}, {
        strokeWidth: Number(e.value)
      });
      _this.props.updateItem(item);
    });
    _defineProperty(_this, "customCornerCurve", function (e) {
      var item = _objectSpread$1(_objectSpread$1({}, _this.props.item), {}, {
        cornerRadius: Number(e.value)
      });
      _this.props.updateItem(item);
    });
    _defineProperty(_this, "rotationSnaps", function (e) {
      var num = Number(e.value);
      var pos = {
        x: _this.props.item.x,
        y: _this.props.item.y
      };
      var _dragBoundItem = dragBoundItem(pos, _this.props.layout, _this.props.item, num),
        x = _dragBoundItem.x,
        y = _dragBoundItem.y;
      if (!isNaN(num)) {
        var item = _objectSpread$1(_objectSpread$1({}, _this.props.item), {}, {
          rotation: num,
          x: x,
          y: y
        });
        _this.props.updateItem(item);
      }
    });
    _defineProperty(_this, "writeText", function (e) {
      var item = _objectSpread$1(_objectSpread$1({}, _this.props.item), {}, {
        text: e.target.value
      });
      _this.props.updateItem(item);
    });
    _defineProperty(_this, "customText", function () {
      var nextCustomText, nextTextValue;
      if (_this.props.item) {
        nextCustomText = !_this.props.item.customText;
        nextCustomText ? nextTextValue = 'Enter prompt' : nextTextValue = 'Text';
      }
      _this.props.updateItem(_objectSpread$1(_objectSpread$1({}, _this.props.item), {}, {
        customText: nextCustomText,
        text: nextCustomText ? '' : nextTextValue,
        prompt: nextCustomText ? nextTextValue : ''
      }));
    });
    _defineProperty(_this, "writePrompt", function (e) {
      var item = _objectSpread$1(_objectSpread$1({}, _this.props.item), {}, {
        prompt: e.target.value
      });
      _this.props.updateItem(item);
    });
    _defineProperty(_this, "customVariableGroup", function (e) {
      var variableGroup = _this.props.variableGroup;
      var value = variableGroup.find(function (el) {
        return el.label === e.value;
      }).variables[0];
      var item = _objectSpread$1(_objectSpread$1({}, _this.props.item), {}, {
        varCode: value.code
      });
      _this.props.updateItem(item);
    });
    _defineProperty(_this, "customVariable", function (e) {
      var item = _objectSpread$1(_objectSpread$1({}, _this.props.item), {}, {
        varCode: e.value
      });
      _this.props.updateItem(item);
    });
    _defineProperty(_this, "customBarcodeGroup", function (e) {
      var barcodeVariables = _this.props.barcodeVariables;
      var value = barcodeVariables.find(function (el) {
        return el.label === e.value;
      }).variables[0];
      var item = _objectSpread$1(_objectSpread$1({}, _this.props.item), {}, {
        varCode: value.code
      });
      _this.props.updateItem(item);
    });
    _defineProperty(_this, "customBarcode", function (e) {
      var item = _objectSpread$1(_objectSpread$1({}, _this.props.item), {}, {
        varCode: e.value
      });
      _this.props.updateItem(item);
    });
    _defineProperty(_this, "customBarcodeType", function (e) {
      var item = _objectSpread$1(_objectSpread$1({}, _this.props.item), {}, {
        type: e.value
      });
      _this.props.updateItem(item);
    });
    _defineProperty(_this, "handleActiveItemChange", function (_ref) {
      var id = _ref.id;
      _this.props.selectItem(id);
    });
    _this.state = {
      printer: ''
    };
    _this.printRef = /*#__PURE__*/React.createRef();
    _this.printers = [{
      label: '<' + props.t('lbl.systemDefault', 'System default') + '>',
      value: DEFAULT_PRINTER
    }];
    if (window.qtside) {
      // Get printers available on the system
      window.qtside.printer.availablePrinters.connect(_this.updatePrintersList);
      window.qtside.printer.listAvailablePrinters();
    }
    return _this;
  }
  _inherits(Layout, _Component);
  return _createClass(Layout, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        t = _this$props.t,
        item = _this$props.item,
        items = _this$props.items,
        updateItem = _this$props.updateItem,
        moveItemBottom = _this$props.moveItemBottom,
        moveItemDown = _this$props.moveItemDown,
        moveItemTop = _this$props.moveItemTop,
        moveItemUp = _this$props.moveItemUp,
        layout = _this$props.layout,
        selectItem = _this$props.selectItem,
        selectedItemId = _this$props.selectedItemId,
        onUndo = _this$props.onUndo,
        onRedo = _this$props.onRedo,
        stageForwardedRef = _this$props.stageForwardedRef,
        variableGroup = _this$props.variableGroup,
        orderItem = _this$props.orderItem,
        formatters = _this$props.formatters,
        barcodeVariables = _this$props.barcodeVariables,
        move = _this$props.move,
        deleteItem = _this$props.deleteItem,
        createItem = _this$props.createItem;

      // map variable codes to info objects
      var codeToInfo = {};
      for (var _i = 0, _arr = [variableGroup, barcodeVariables]; _i < _arr.length; _i++) {
        var category = _arr[_i];
        var _iterator = _createForOfIteratorHelper(category),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var group = _step.value;
            var _iterator2 = _createForOfIteratorHelper(group.variables),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var variable = _step2.value;
                codeToInfo[variable.code] = variable;
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
        className: "layout__container"
      }, /*#__PURE__*/React.createElement(Col, {
        style: {
          paddingLeft: 0
        }
      }, /*#__PURE__*/React.createElement(Row, {
        className: "mr-8 ml-8",
        style: {
          height: '4rem',
          marginBottom: '0.5rem'
        }
      }, /*#__PURE__*/React.createElement(Col, {
        xs: 3,
        style: {
          padding: 0,
          maxWidth: '150px'
        }
      }, /*#__PURE__*/React.createElement("p", {
        className: "currentItem__title margin-0"
      }, t('lbl.activeItem', 'Active Item')), /*#__PURE__*/React.createElement(Select, {
        isDisabled: items.length === 0 || false,
        value: item ? {
          id: item.id,
          value: item.name,
          label: item.name
        } : {
          value: null,
          label: 'None'
        },
        options: items ? items.map(function (item) {
          return {
            id: item.id,
            value: item.name,
            label: item.name
          };
        }) : null,
        onChange: this.handleActiveItemChange
      })), /*#__PURE__*/React.createElement(TypeSettings$1, {
        variableGroup: variableGroup,
        barcodeVariables: barcodeVariables,
        item: item,
        rotationSnaps: this.rotationSnaps,
        writeText: this.writeText,
        writePrompt: this.writePrompt,
        customText: this.customText,
        toggleCustomText: item ? item.customText : false,
        customStrokeWidth: this.customStrokeWidth,
        customCornerCurve: this.customCornerCurve,
        customVariableGroup: this.customVariableGroup,
        customVariable: this.customVariable,
        customBarcode: this.customBarcode,
        customBarcodeType: this.customBarcodeType,
        customBarcodeGroup: this.customBarcodeGroup,
        codeToInfo: codeToInfo
      })), /*#__PURE__*/React.createElement(Row, {
        className: "ml-8 mr-8"
      }, /*#__PURE__*/React.createElement(Alignments, {
        item: item,
        updateItem: updateItem,
        moveItemBottom: moveItemBottom,
        moveItemDown: moveItemDown,
        moveItemTop: moveItemTop,
        moveItemUp: moveItemUp
      })), /*#__PURE__*/React.createElement(Row, {
        className: "main__container"
      }, /*#__PURE__*/React.createElement(Col, {
        xs: 9,
        className: "main__col"
      }, /*#__PURE__*/React.createElement(Row, {
        className: "main__edit"
      }, /*#__PURE__*/React.createElement(Col, {
        xs: 2,
        style: {
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          padding: 0
        }
      }, /*#__PURE__*/React.createElement("p", {
        className: "margin-0"
      }, t('lbl.editor', 'Editor')), /*#__PURE__*/React.createElement("div", {
        className: "main__btns"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: onUndo,
        title: "Undo",
        className: "font__icon margin-0"
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: "rotate-left"
      })), /*#__PURE__*/React.createElement(Button, {
        onClick: onRedo,
        title: "Redo",
        className: "font__icon"
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: "rotate-right"
      }))), /*#__PURE__*/React.createElement(Button, {
        onClick: this.props.toggleShowPreview,
        title: "Preview",
        style: {
          color: this.props.showPreview ? 'white' : 'unset',
          backgroundColor: this.props.showPreview ? '#458DD5' : 'unset',
          border: 'none'
        }
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: "eye"
      }))), /*#__PURE__*/React.createElement(Col, {
        xs: 10
      }, !this.props.showPreview ? /*#__PURE__*/React.createElement(Editor, {
        currentItem: item,
        items: items,
        layout: layout,
        createItem: createItem,
        selectItem: selectItem,
        updateItem: updateItem,
        selectedItemId: selectedItemId,
        codeToInfo: codeToInfo,
        move: move,
        deleteItem: deleteItem
      }) : /*#__PURE__*/React.createElement(FinalPreview, {
        ref: stageForwardedRef,
        layout: layout,
        selectItem: selectItem,
        updateItem: updateItem,
        selectedItemId: selectedItemId,
        orderItem: orderItem,
        formatters: formatters,
        move: move
      })))), /*#__PURE__*/React.createElement(Col, {
        className: "labelSettings__container",
        xs: 3
      }, /*#__PURE__*/React.createElement(LabelItemsSettings, {
        item: item,
        updateItem: updateItem,
        layout: layout,
        rotationSnaps: this.rotationSnaps
      }))))), /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.props.showPrinterSelectionModal
      }, /*#__PURE__*/React.createElement(ModalHeader, {
        toggle: this.props.toggleShowPrinterModal
      }, t('lbl.selectPrinter', 'Select printer')), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(FinalPreview, {
        ref: this.printRef,
        layout: layout,
        selectItem: selectItem,
        updateItem: updateItem,
        selectedItemId: selectedItemId,
        orderItem: orderItem,
        formatters: formatters,
        move: move
      }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
        xs: 8,
        className: "p-0 pr-8"
      }, /*#__PURE__*/React.createElement(Select, {
        menuPlacement: "auto",
        isSearchable: false,
        value: {
          label: this.state.printer,
          value: this.state.printer
        },
        onChange: function onChange(value) {
          return _this2.setState({
            printer: value.value
          });
        },
        options: this.printers
      })))), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Row, {
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement(Col, {
        className: "m-16"
      }, /*#__PURE__*/React.createElement(Button, {
        "data-testid": "btn_cancel_print",
        onClick: this.props.toggleShowPrinterModal
      }, t('fn.cancel', 'Cancel'))), /*#__PURE__*/React.createElement(Col, {
        className: "m-16"
      }, /*#__PURE__*/React.createElement(Button, {
        "data-testid": "btn_print_label",
        primary: true,
        onClick: function onClick() {
          return _this2.printRef.current.printRequested(_this2.state.printer);
        }
      }, t('fn.print', 'Print')))))));
    }
  }]);
}(Component);
Layout.propTypes = {
  t: PropTypes.func.isRequired,
  item: PropTypes.object,
  layout: PropTypes.object,
  items: PropTypes.array,
  showAlignment: PropTypes.bool,
  showEdit: PropTypes.bool,
  createItem: PropTypes.func,
  selectItem: PropTypes.func,
  deleteItem: PropTypes.func,
  stageForwardedRef: PropTypes.object,
  onUndo: PropTypes.func,
  onRedo: PropTypes.func,
  updateItem: PropTypes.func,
  moveItemDown: PropTypes.func,
  moveItemUp: PropTypes.func,
  moveItemTop: PropTypes.func,
  moveItemBottom: PropTypes.func,
  selectedItemId: PropTypes.number,
  variableGroup: PropTypes.array,
  orderItem: PropTypes.object,
  formatters: PropTypes.object,
  barcodeVariables: PropTypes.array,
  move: PropTypes.bool,
  showPreview: PropTypes.bool,
  toggleShowPreview: PropTypes.func,
  showPrinterSelectionModal: PropTypes.bool,
  toggleShowPrinterModal: PropTypes.func
};
function mapStateToProps(state) {
  return {
    canUndo: state.undoHistory.undoQueue.length > 0,
    canRedo: state.undoHistory.redoQueue.length > 0,
    item: selectors$1.itemById(state, selectors.selectedItemId(state)),
    uploads: selectors$1.itemsAsArray(state),
    layout: state.layout,
    items: selectors$1.itemsAsArray(state),
    selectedItemId: selectors.selectedItemId(state),
    move: selectors.move(state)
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    onUndo: actions$2.undo,
    onRedo: actions$2.redo,
    createItem: actions$1.createItem,
    updateItem: actions$1.updateItem,
    deleteItem: actions$1.deleteItem,
    moveItem: actions$1.moveItem,
    updatePage: actions$1.updatePage,
    updateReadOnly: actions$1.updateReadOnly,
    updateMoveItem: actions.updateMoveItem,
    resetLayout: actions$1.resetLayout,
    selectItem: actions.selectItem,
    moveItemUp: actions$1.moveItemUp,
    moveItemDown: actions$1.moveItemDown,
    moveItemTop: actions$1.moveItemTop,
    moveItemBottom: actions$1.moveItemBottom
  }, dispatch);
}
var ConnectedLayout = withTranslation('translations')(connect(mapStateToProps, mapDispatchToProps)(Layout));

// eslint-disable-next-line react/display-name
var FinalLayout = /*#__PURE__*/forwardRef(function finalLayout(props, ref) {
  return /*#__PURE__*/React.createElement(ConnectedLayout, _extends({}, props, {
    stageForwardedRef: ref
  }));
});

// Could be used for automatic language detection, but seems to cause fi-FI as language code instead of just fi
// import LanguageDetector from 'i18next-browser-languagedetector';
//i18n.use(XHR).use(LanguageDetector).init({
i18n.use(HttpApi).init({
  // we init with resources
  lng: 'en',
  fallbackLng: 'en',
  debug: false,
  // have a common namespace used around the full app
  ns: ['translations'],
  defaultNS: 'translations',
  keySeparator: false,
  // we use content as keys
  nsSeparator: false,
  // we use content as keys

  interpolation: {
    escapeValue: false,
    // not needed for react!!
    formatSeparator: ','
  },
  react: {
    useSuspense: true
  },
  backend: {
    loadPath: '/translations/{{lng}}/{{ns}}'
  }
});

var Container = function Container(props) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: '100% !important',
      padding: 0
    }
  }, props.children);
};
Container.propTypes = {
  children: PropTypes.node
};

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// import 'bootstrap/dist/css/bootstrap.min.css';

//Add FontAwesomeIcon to the whole app
library.add(faPrint, faFile, faFolder, faSave, faPen, faQrcode, faBarcode, faMinus, faBold, faItalic, faUnderline, faPaintBrush, faCopy, faDownload, faFileImport, faSpinner, faAlignLeft, faAlignRight, faAlignCenter, faImage, faImagePortrait, faRotateLeft, faRotateRight, faEye, faT, faCode, faCircle, faXmark, faSquare);
var App = /*#__PURE__*/function (_Component) {
  function App(props) {
    var _this;
    _classCallCheck(this, App);
    _this = _callSuper(this, App, [props]);
    _defineProperty(_this, "toggleShowPreview", function () {
      _this.setState(function (prevState) {
        return {
          showPreview: !prevState.showPreview
        };
      });
    });
    _defineProperty(_this, "toggleShowPrinterModal", function () {
      _this.setState(function (old) {
        return {
          showPrinterSelectionModal: !old.showPrinterSelectionModal
        };
      });
    });
    _this.state = {
      initialLayout: null,
      showPreview: false
    };
    _this.stageRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  _inherits(App, _Component);
  return _createClass(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      store.dispatch(actions.toggleNewModal(this.props.isNewLabel));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        variableGroup = _this$props.variableGroup,
        orderItem = _this$props.orderItem,
        formatters = _this$props.formatters,
        barcodeVariables = _this$props.barcodeVariables;
      return /*#__PURE__*/React.createElement(Provider, {
        store: store
      }, /*#__PURE__*/React.createElement(Container, {
        className: "container__width"
      }, /*#__PURE__*/React.createElement(I18nextProvider, {
        i18n: i18n
      }, /*#__PURE__*/React.createElement(Suspense, {
        fallback: /*#__PURE__*/React.createElement("div", null, "Loading...")
      }, /*#__PURE__*/React.createElement(FinalNavbar, {
        showPreview: this.state.showPreview,
        handleExportClick: this.toggleShowPrinterModal,
        handleSaveDB: this.props.handleSaveDB,
        ref: this.stageRef,
        axios: this.props.axios,
        orderItem: orderItem,
        formatters: formatters
      }), /*#__PURE__*/React.createElement(Row, {
        className: "content__container m-0",
        style: {
          height: 'calc(100vh - 120px)'
        }
      }, /*#__PURE__*/React.createElement(Col, {
        style: {
          padding: 0
        },
        xs: 2
      }, /*#__PURE__*/React.createElement(Toolbar$1, null)), /*#__PURE__*/React.createElement(Col, {
        style: {
          padding: 0
        },
        xs: 10
      }, /*#__PURE__*/React.createElement(FinalLayout, {
        ref: this.stageRef,
        showPreview: this.state.showPreview,
        toggleShowPreview: this.toggleShowPreview,
        variableGroup: variableGroup,
        orderItem: orderItem,
        formatters: formatters,
        barcodeVariables: barcodeVariables,
        toggleShowPrinterModal: this.toggleShowPrinterModal,
        showPrinterSelectionModal: this.state.showPrinterSelectionModal
      })))))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (!_.isEqual(state.initialLayout, props.initialLayout) && props.initialLayout) {
        store.dispatch(actions$1.setInitialLayout(props.initialLayout));
        return _objectSpread(_objectSpread({}, state), {}, {
          initialLayout: _.cloneDeep(props.initialLayout)
        });
      }
      return state;
    }
  }]);
}(Component);
App.propTypes = {
  handleSaveDB: PropTypes.func,
  axios: PropTypes.any,
  // Axios library
  initialLayout: PropTypes.object,
  variableGroup: PropTypes.array,
  // Object containing actual variables to be shown on POS labels
  orderItem: PropTypes.object,
  // Object containing data for variables to be shown on preview
  barcodeVariables: PropTypes.array,
  // Barcode variables (Search values from orderItem)
  formatters: PropTypes.object,
  // Functions to call to get the data in required format
  isNewLabel: PropTypes.bool // Shows the new label modal
};
App.defaultProps = {
  handleSaveDB: function handleSaveDB() {
    return console.log('Add save func');
  },
  axios: null
};

var index = {
  EasyPrint: App
};

export { BARCODE_CODE128, BARCODE_CODE39, BARCODE_DATABAR_STACKED, BARCODE_EAN13, BARCODE_EAN8, BARCODE_GS_128, BARCODE_QRCODE, BARCODE_UPCA, App as EasyPrint, FinalPreview as Preview, assignVariables, computeGTINCheckDigit, index as default };
//# sourceMappingURL=index.es.js.map
